export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const PragmaticPlayGames = {
  gatesofolympus: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympus.webp",
    alt: "Gates of Olympus",
    name: "Gates of Olympus",
  },
  sweetbonanza: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanza.webp",
    alt: "Sweet Bonanza",
    name: "Sweet Bonanza",
  },
  sugarrush: {
    redirectUrl: "/casino/pragmaticplay-sugar-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarRush.webp",
    alt: "Sugar Rush",
    name: "Sugar Rush",
  },
  bigbassbonanza: {
    redirectUrl: "/casino/pragmaticplay-big-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBonanza.webp",
    alt: "Big Bass Bonanza",
    name: "Big Bass Bonanza",
  },
  bigbasshalloween: {
    redirectUrl: "/casino/pragmaticplay-big-bass-halloween",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassHalloween.webp",
    alt: "Big Bass Halloween",
    name: "Big Bass Halloween",
  },
  bigbasssplash: {
    redirectUrl: "/casino/pragmaticplay-big-bass-splash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassSplash.webp",
    alt: "Big Bass Splash",
    name: "Big Bass Splash",
  },
  thedoghouse: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouse.webp",
    alt: "The Dog House",
    name: "The Dog House",
  },
  gatesofhades: {
    redirectUrl: "/casino/pragmaticplay-gates-of-hades",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofHades.webp",
    alt: "Gates of Hades",
    name: "Gates of Hades",
  },
  zombieschoolmegaways: {
    redirectUrl: "/casino/pragmaticplay-zombie-school-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ZombieSchoolMegaways.webp",
    alt: "Zombie School Megaways",
    name: "Zombie School Megaways",
  },
  zombiecarnival: {
    redirectUrl: "/casino/pragmaticplay-zombie-carnival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ZombieCarnival.webp",
    alt: "Zombie Carnival",
    name: "Zombie Carnival",
  },
  zeusvshadesgodsofwar: {
    redirectUrl: "/casino/pragmaticplay-zeus-vs-hades-gods-of-war",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ZeusvsHades-GodsofWar.webp",
    alt: "Zeus vs Hades  Gods of War",
    name: "Zeus vs Hades  Gods of War",
  },
  youcanpiggybankonit: {
    redirectUrl: "/casino/pragmaticplay-you-can-piggy-bank-on-it",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YouCanPiggyBankonIt.webp",
    alt: "You Can Piggy Bank On It",
    name: "You Can Piggy Bank On It",
  },
  yollarinkrali: {
    redirectUrl: "/casino/pragmaticplay-yollarin-krali",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YollarinKrali.webp",
    alt: "Yollarin Krali",
    name: "Yollarin Krali",
  },
  yisunshin: {
    redirectUrl: "/casino/pragmaticplay-yi-sun-shin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YiSunShin.webp",
    alt: "Yi Sun Shin",
    name: "Yi Sun Shin",
  },
  yetiquest: {
    redirectUrl: "/casino/pragmaticplay-yeti-quest",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YetiQuest.webp",
    alt: "Yeti Quest",
    name: "Yeti Quest",
  },
  yearofthedragonking: {
    redirectUrl: "/casino/pragmaticplay-year-of-the-dragon-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YearofTheDragonKing.webp",
    alt: "Year Of The Dragon King",
    name: "Year Of The Dragon King",
  },
  yabotreeofriches: {
    redirectUrl: "/casino/pragmaticplay-yabo-tree-of-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/YaboTreeofRiches.webp",
    alt: "Yabo Tree of Riches",
    name: "Yabo Tree of Riches",
  },
  xmasspark: {
    redirectUrl: "/casino/pragmaticplay-xmas-spark",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/XmasSpark.webp",
    alt: "Xmas Spark",
    name: "Xmas Spark",
  },
  wukongrush: {
    redirectUrl: "/casino/pragmaticplay-wukong-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WukongRush.webp",
    alt: "Wukong Rush",
    name: "Wukong Rush",
  },
  wolfgoldultimate: {
    redirectUrl: "/casino/pragmaticplay-wolf-gold-ultimate",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WolfGoldUltimate.webp",
    alt: "Wolf Gold Ultimate",
    name: "Wolf Gold Ultimate",
  },
  wolfgolddice: {
    redirectUrl: "/casino/pragmaticplay-wolf-gold-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WolfGoldDice.webp",
    alt: "Wolf Gold Dice",
    name: "Wolf Gold Dice",
  },
  wolfgold4pack: {
    redirectUrl: "/casino/pragmaticplay-wolf-gold-4-pack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WolfGold4Pack.webp",
    alt: "Wolf Gold 4 Pack",
    name: "Wolf Gold 4 Pack",
  },
  wolfgold: {
    redirectUrl: "/casino/pragmaticplay-wolf-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WolfGold.webp",
    alt: "Wolf Gold",
    name: "Wolf Gold",
  },
  witchheartmegaways: {
    redirectUrl: "/casino/pragmaticplay-witch-heart-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WitchHeartMegaways.webp",
    alt: "Witch Heart Megaways",
    name: "Witch Heart Megaways",
  },
  wisdomofathena1000: {
    redirectUrl: "/casino/pragmaticplay-wisdom-of-athena-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WisdomofAthena1000.webp",
    alt: "Wisdom Of Athena 1000",
    name: "Wisdom Of Athena 1000",
  },
  wisdomofathena: {
    redirectUrl: "/casino/pragmaticplay-wisdom-of-athena",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WisdomofAthena.webp",
    alt: "Wisdom of Athena",
    name: "Wisdom of Athena",
  },
  wildmansuperbonanza: {
    redirectUrl: "/casino/pragmaticplay-wildman-super-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildmanSuperBonanza.webp",
    alt: "Wildman Super Bonanza",
    name: "Wildman Super Bonanza",
  },
  wildies: {
    redirectUrl: "/casino/pragmaticplay-wildies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Wildies.webp",
    alt: "Wildies",
    name: "Wildies",
  },
  wildwildebeestwins: {
    redirectUrl: "/casino/pragmaticplay-wild-wildebeest-wins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildebeestWins.webp",
    alt: "Wild Wildebeest Wins",
    name: "Wild Wildebeest Wins",
  },
  wildwildwolf: {
    redirectUrl: "/casino/pragmaticplay-wild-wild-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildWolf.webp",
    alt: "Wild Wild Wolf",
    name: "Wild Wild Wolf",
  },
  wildwildriches: {
    redirectUrl: "/casino/pragmaticplay-wild-wild-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildRiches.webp",
    alt: "Wild Wild Riches",
    name: "Wild Wild Riches",
  },
  wildwildpearls: {
    redirectUrl: "/casino/pragmaticplay-wild-wild-pearls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildPearls.webp",
    alt: "Wild Wild Pearls",
    name: "Wild Wild Pearls",
  },
  wildwildjoker: {
    redirectUrl: "/casino/pragmaticplay-wild-wild-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildJoker.webp",
    alt: "Wild Wild Joker",
    name: "Wild Wild Joker",
  },
  wildwildbananas: {
    redirectUrl: "/casino/pragmaticplay-wild-wild-bananas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWildBananas.webp",
    alt: "Wild Wild Bananas",
    name: "Wild Wild Bananas",
  },
  wildwestgoldmegaways: {
    redirectUrl: "/casino/pragmaticplay-wild-west-gold-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWestGoldMegaways.webp",
    alt: "Wild West Gold Megaways",
    name: "Wild West Gold Megaways",
  },
  wildwestgoldblazingbounty: {
    redirectUrl: "/casino/pragmaticplay-wild-west-gold-blazing-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWestGoldBlazingBounty.webp",
    alt: "Wild West Gold Blazing Bounty",
    name: "Wild West Gold Blazing Bounty",
  },
  wildwestgold: {
    redirectUrl: "/casino/pragmaticplay-wild-west-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWestGold.webp",
    alt: "Wild West Gold",
    name: "Wild West Gold",
  },
  wildwestbounty: {
    redirectUrl: "/casino/pragmaticplay-wild-west-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWestBounty.webp",
    alt: "Wild West Bounty",
    name: "Wild West Bounty",
  },
  wildwalker: {
    redirectUrl: "/casino/pragmaticplay-wild-walker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildWalker.webp",
    alt: "Wild Walker",
    name: "Wild Walker",
  },
  wildspells: {
    redirectUrl: "/casino/pragmaticplay-wild-spells",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildSpells.webp",
    alt: "Wild Spells",
    name: "Wild Spells",
  },
  wildpixies: {
    redirectUrl: "/casino/pragmaticplay-wild-pixies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildPixies.webp",
    alt: "Wild Pixies",
    name: "Wild Pixies",
  },
  wildhopdrop: {
    redirectUrl: "/casino/pragmaticplay-wild-hopanddrop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildHop&Drop.webp",
    alt: "Wild Hop&Drop",
    name: "Wild Hop&Drop",
  },
  wildgladiators: {
    redirectUrl: "/casino/pragmaticplay-wild-gladiators",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildGladiators.webp",
    alt: "Wild Gladiators",
    name: "Wild Gladiators",
  },
  wilddepths: {
    redirectUrl: "/casino/pragmaticplay-wild-depths",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildDepths.webp",
    alt: "Wild Depths",
    name: "Wild Depths",
  },
  wildcelebritybusmegaways: {
    redirectUrl: "/casino/pragmaticplay-wild-celebrity-bus-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildCelebrityBusMegaways.webp",
    alt: "Wild Celebrity Bus Megaways",
    name: "Wild Celebrity Bus Megaways",
  },
  wildbooster: {
    redirectUrl: "/casino/pragmaticplay-wild-booster",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildBooster.webp",
    alt: "Wild Booster",
    name: "Wild Booster",
  },
  wildbisoncharge: {
    redirectUrl: "/casino/pragmaticplay-wild-bison-charge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildBisonCharge.webp",
    alt: "Wild Bison Charge",
    name: "Wild Bison Charge",
  },
  wildbeachxmasparty: {
    redirectUrl: "/casino/pragmaticplay-wild-beach-xmas-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildBeachXmasParty.webp",
    alt: "Wild Beach Xmas Party",
    name: "Wild Beach Xmas Party",
  },
  wildbeachparty: {
    redirectUrl: "/casino/pragmaticplay-wild-beach-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WildBeachParty.webp",
    alt: "Wild Beach Party",
    name: "Wild Beach Party",
  },
  wheelogold: {
    redirectUrl: "/casino/pragmaticplay-wheel-ogold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WheelOGold.webp",
    alt: "Wheel O'Gold",
    name: "Wheel O'Gold",
  },
  wavesofposeidon: {
    redirectUrl: "/casino/pragmaticplay-waves-of-poseidon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WavesofPoseidon.webp",
    alt: "Waves of Poseidon",
    name: "Waves of Poseidon",
  },

  LuckysWildPub: {
    redirectUrl: "/casino/pragmaticplay-luckys-wild-pub",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckysWildPub.webp",
    alt: "Lucky’s Wild Pub",
    name: "Lucky’s Wild Pub",
  },
  LuckyNewYear: {
    redirectUrl: "/casino/pragmaticplay-lucky-new-year",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyNewYear.webp",
    alt: "Lucky New Year",
    name: "Lucky New Year",
  },
  LuckyLightning: {
    redirectUrl: "/casino/pragmaticplay-lucky-lightning",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyLightning.webp",
    alt: "Lucky Lightning",
    name: "Lucky Lightning",
  },
  LuckyGraceAndCharm: {
    redirectUrl: "/casino/pragmaticplay-lucky-grace-and-charm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyGraceAndCharm.webp",
    alt: "Lucky Grace And Charm",
    name: "Lucky Grace And Charm",
  },
  LuckyFishingMegaways: {
    redirectUrl: "/casino/pragmaticplay-lucky-fishing-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyFishingMegaways.webp",
    alt: "Lucky Fishing Megaways",
    name: "Lucky Fishing Megaways",
  },
  LuckyDragons: {
    redirectUrl: "/casino/pragmaticplay-lucky-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyDragons.webp",
    alt: "Lucky Dragons",
    name: "Lucky Dragons",
  },
  LuckyDragonBall: {
    redirectUrl: "/casino/pragmaticplay-lucky-dragon-ball",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LuckyDragonBall.webp",
    alt: "Lucky Dragon Ball",
    name: "Lucky Dragon Ball",
  },
  LokisRiches: {
    redirectUrl: "/casino/pragmaticplay-lokis-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LokisRiches.webp",
    alt: "Loki's Riches",
    name: "Loki's Riches",
  },
  LobsterBobSeaFoodandWinIt: {
    redirectUrl: "/casino/pragmaticplay-lobster-bobs-sea-food-and-win-it",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LobsterBobsSeaFoodandWinIt.webp",
    alt: "Lobster Bob's Sea Food and Win It",
    name: "Lobster Bob's Sea Food and Win It",
  },
  LobsterBobsCrazyCrabShack: {
    redirectUrl: "/casino/pragmaticplay-lobster-bobs-crazy-crab-shack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LobsterBobsCrazyCrabShack.webp",
    alt: "Lobster Bobs Crazy Crab Shack",
    name: "Lobster Bobs Crazy Crab Shack",
  },
  LittleGemHoldandSpin: {
    redirectUrl: "/casino/pragmaticplay-waves-of-poseidon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LittleGemHoldandSpin.webp",
    alt: "Little Gem Hold and Spin",
    name: "Little Gem Hold and Spin",
  },
  LeprechaunSong: {
    redirectUrl: "/casino/pragmaticplay-leprechaun-song",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LeprechaunSong.webp",
    alt: "Leprechaun Song",
    name: "Leprechaun Song",
  },
  LeprechaunCarol: {
    redirectUrl: "/casino/pragmaticplay-leprechaun-carol",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LeprechaunCarol.webp",
    alt: "Leprechaun Carol",
    name: "Leprechaun Carol",
  },
  LeprechaunCarol: {
    redirectUrl: "/casino/pragmaticplay-legend-of-heroes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LegendofHeroes.webp",
    alt: "Legend of Heroes",
    name: "Legend of Heroes",
  },
  LegendofGaruda: {
    redirectUrl: "/casino/pragmaticplay-legend-of-garuda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LegendofGaruda.webp",
    alt: "Legend of Garuda",
    name: "Legend of Garuda",
  },
  LaughingFortune: {
    redirectUrl: "/casino/pragmaticplay-laughing-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LaughingFortune.webp",
    alt: "Laughing Fortune",
    name: "Laughing Fortune",
  },
  LampOfInfinity: {
    redirectUrl: "/casino/pragmaticplay-laughing-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LampOfInfinity.webp",
    alt: "Lamp Of Infinity",
    name: "Lamp Of Infinity",
  },
  LadyBugLuck: {
    redirectUrl: "/casino/pragmaticplay-ladybug-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LadyBugLuck.webp",
    alt: "LadyBug Luck",
    name: "LadyBug Luck",
  },
  LadyGodiva: {
    redirectUrl: "/casino/pragmaticplay-lady-godiva",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LadyGodiva.webp",
    alt: "Lady Godiva",
    name: "Lady Godiva",
  },
  ladydmegaways: {
    redirectUrl: "/casino/pragmaticplay-lady-d-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LadyDMegaways.webp",
    alt: "Lady D Megaways",
    name: "Lady D Megaways",
  },

  ladbrokesheat: {
    redirectUrl: "/casino/pragmaticplay-ladbrokes-heat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LadbrokesHeat.webp",
    alt: "Ladbrokes Heat",
    name: "Ladbrokes Heat",
  },
  lamokawildpowernudge: {
    redirectUrl: "/casino/pragmaticplay-la-moka-wild-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/LaMokaWildPowernudge.webp",
    alt: "La Moka Wild Powernudge",
    name: "La Moka Wild Powernudge",
  },
  koipond: {
    redirectUrl: "/casino/pragmaticplay-koi-pond",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KoiPond.webp",
    alt: "Koi Pond",
    name: "Koi Pond",
  },
  koibonanzajackpotplay: {
    redirectUrl: "/casino/pragmaticplay-koi-bonanza-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KoiBonanzaJackpotPlay.webp",
    alt: "Koi Bonanza Jackpot Play",
    name: "Koi Bonanza Jackpot Play",
  },
  knighthotspotz: {
    redirectUrl: "/casino/pragmaticplay-knight-hot-spotz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KnightHotSpotz.webp",
    alt: "Knight Hot Spotz",
    name: "Knight Hot Spotz",
  },
  kingdomofthedead: {
    redirectUrl: "/casino/pragmaticplay-kingdom-of-the-dead",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KingdomofTheDead.webp",
    alt: "Kingdom of The Dead",
    name: "Kingdom of The Dead",
  },
  kingdomofatlantisjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-kingdom-of-atlantis-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KingdomofAtlantisJackpotPlay.webp",
    alt: "Kingdom of Atlantis Jackpot Play",
    name: "Kingdom of Atlantis Jackpot Play",
  },
  kingdomofasgard: {
    redirectUrl: "/casino/pragmaticplay-kingdom-of-asgard",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KingdomofAsgard.webp",
    alt: "Kingdom of Asgard",
    name: "Kingdom of Asgard",
  },
  killordie: {
    redirectUrl: "/casino/pragmaticplay-kill-or-die",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KillorDie.webp",
    alt: "Kill or Die",
    name: "Kill or Die",
  },
  jurassicgiants: {
    redirectUrl: "/casino/pragmaticplay-jurassic-giants",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JurassicGiants.webp",
    alt: "Jurassic Giants",
    name: "Jurassic Giants",
  },
  junglegorilla: {
    redirectUrl: "/casino/pragmaticplay-jungle-gorilla",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JungleGorilla.webp",
    alt: "Jungle Gorilla",
    name: "Jungle Gorilla",
  },
  juicyfruitsmultihold: {
    redirectUrl: "/casino/pragmaticplay-juicy-fruits-multihold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JuicyFruitsMultihold.webp",
    alt: "Juicy Fruits Multihold",
    name: "Juicy Fruits Multihold",
  },
  juicyfruits: {
    redirectUrl: "/casino/pragmaticplay-juicy-fruits",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JuicyFruits.webp",
    alt: "Juicy Fruits",
    name: "Juicy Fruits",
  },
  journeytothewest: {
    redirectUrl: "/casino/pragmaticplay-journey-to-the-west",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JourneytotheWest.webp",
    alt: "Journey to the West",
    name: "Journey to the West",
  },
  jokersjewelstm: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewelstm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewels.webp",
    alt: "Joker's Jewels™",
    name: "Joker's Jewels™",
  },
  jokersjewelswild: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewels-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewelsWild.webp",
    alt: "Jokers Jewels Wild",
    name: "Jokers Jewels Wild",
  },
  jokersjewelshot: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewels-hot-u7047",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewelsHot.webp",
    alt: "Joker's Jewels Hot",
    name: "Joker's Jewels Hot",
  },
  jokersjewels: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewels.webp",
    alt: "Joker's Jewels",
    name: "Joker's Jewels",
  },
  jokersjewelsdice: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewels-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewelsDice.webp",
    alt: "Joker’s Jewels Dice",
    name: "Joker’s Jewels Dice",
  },
  jokersjewelscash: {
    redirectUrl: "/casino/pragmaticplay-jokers-jewels-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokersJewelsCash.webp",
    alt: "Joker’s Jewels Cash",
    name: "Joker’s Jewels Cash",
  },
  jokerrace: {
    redirectUrl: "/casino/pragmaticplay-joker-race",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokerRace.webp",
    alt: "Joker Race",
    name: "Joker Race",
  },
  jokerking: {
    redirectUrl: "/casino/pragmaticplay-joker-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokerKing.webp",
    alt: "Joker King",
    name: "Joker King",
  },
  jokerblastbonanza: {
    redirectUrl: "/casino/pragmaticplay-joker-blast-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JokerBlastBonanza.webp",
    alt: "Joker Blast Bonanza",
    name: "Joker Blast Bonanza",
  },
  joiasdaestrela: {
    redirectUrl: "/casino/pragmaticplay-joias-da-estrela",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JoiasdaEstrela.webp",
    alt: "Joias da Estrela",
    name: "Joias da Estrela",
  },
  johnhunternellanticaroma: {
    redirectUrl: "/casino/pragmaticplay-john-hunter-nellantica-roma",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JohnHunterNellAnticaRoma.webp",
    alt: "John Hunter Nell’Antica Roma",
    name: "John Hunter Nell’Antica Roma",
  },
  johnhunterandthetombofthescarabqueen: {
    redirectUrl:
      "/casino/pragmaticplay-john-hunter-and-the-tomb-of-the-scarab-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/johnhunterandthetombofthescarabqueen.jpg",
    alt: "John Hunter and the Tomb of the Scarab Queen",
    name: "John Hunter and the Tomb of the Scarab Queen",
  },
  johnhunterandthequestforbermudariches: {
    redirectUrl:
      "/casino/pragmaticplay-john-hunter-and-the-quest-for-bermuda-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JohnHunterandtheQuestforBermudaRiches.webp",
    alt: "John Hunter and the Quest for Bermuda Riches",
    name: "John Hunter and the Quest for Bermuda Riches",
  },
  johnhunterandthemayangods: {
    redirectUrl: "/casino/pragmaticplay-john-hunter-and-the-mayan-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JohnHunterandtheMayanGods.webp",
    alt: "John Hunter and the Mayan Gods",
    name: "John Hunter and the Mayan Gods",
  },
  johnhunterandthebookoftutmegaways: {
    redirectUrl:
      "/casino/pragmaticplay-john-hunter-and-the-book-of-tut-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JohnHunterandtheBookofTutMegaways.webp",
    alt: "John Hunter and the Book of Tut Megaways",
    name: "John Hunter and the Book of Tut Megaways",
  },
  johnhunterandthebookoftut: {
    redirectUrl: "/casino/pragmaticplay-john-hunter-and-the-book-of-tut",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JohnHunterandtheBookofTut.webp",
    alt: "John Hunter and the Book of Tut",
    name: "John Hunter and the Book of Tut",
  },
  jewelrush: {
    redirectUrl: "/casino/pragmaticplay-jewel-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JewelRush.webp",
    alt: "Jewel Rush",
    name: "Jewel Rush",
  },
  jewelbonanza: {
    redirectUrl: "/casino/pragmaticplay-jewel-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JewelBonanza.webp",
    alt: "Jewel Bonanza",
    name: "Jewel Bonanza",
  },
  jasminedreams: {
    redirectUrl: "/casino/pragmaticplay-jasmine-dreams",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JasmineDreams.webp",
    alt: "Jasmine Dreams",
    name: "Jasmine Dreams",
  },
  jajananpasar: {
    redirectUrl: "/casino/pragmaticplay-jajanan-pasar",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JajananPasar.webp",
    alt: "Jajanan Pasar",
    name: "Jajanan Pasar",
  },
  jadebutterfly: {
    redirectUrl: "/casino/pragmaticplay-jade-butterfly",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JadeButterfly.webp",
    alt: "Jade Butterfly",
    name: "Jade Butterfly",
  },
  jackpothunter: {
    redirectUrl: "/casino/pragmaticplay-jackpot-hunter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/JackpotHunter.webp",
    alt: "Jackpot Hunter",
    name: "Jackpot Hunter",
  },
  irishcrown: {
    redirectUrl: "/casino/pragmaticplay-irish-crown",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/IrishCrown.webp",
    alt: "Irish Crown",
    name: "Irish Crown",
  },
  infectivewild: {
    redirectUrl: "/casino/pragmaticplay-infective-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/InfectiveWild.webp",
    alt: "Infective Wild",
    name: "Infective Wild",
  },
  icelobster: {
    redirectUrl: "/casino/pragmaticplay-ice-lobster",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/IceLobster.webp",
    alt: "Ice Lobster",
    name: "Ice Lobster",
  },
  hotfiesta: {
    redirectUrl: "/casino/pragmaticplay-hotfiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Hotfiesta.webp",
    alt: "Hotfiesta",
    name: "Hotfiesta",
  },
  hottoburnmultiplier: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn-multiplier",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurnMultiplier.webp",
    alt: "Hot to Burn Multiplier",
    name: "Hot to Burn Multiplier",
  },
  hottoburnjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurnJackpotPlay.webp",
    alt: "Hot to Burn Jackpot Play",
    name: "Hot to Burn Jackpot Play",
  },
  hottoburnholdandspin: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurnHoldandSpin.webp",
    alt: "Hot to Burn Hold and Spin",
    name: "Hot to Burn Hold and Spin",
  },
  hottoburnextreme: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn-extreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurnExtreme.webp",
    alt: "Hot to Burn Extreme",
    name: "Hot to Burn Extreme",
  },
  hottoburn7deadlyfreespins: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn-7-deadly-free-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurn7DeadlyFreeSpins.webp",
    alt: "Hot to Burn 7 Deadly Free Spins",
    name: "Hot to Burn 7 Deadly Free Spins",
  },
  hottoburn: {
    redirectUrl: "/casino/pragmaticplay-hot-to-burn",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HottoBurn.webp",
    alt: "Hot to Burn",
    name: "Hot to Burn",
  },
  hotsafari: {
    redirectUrl: "/casino/pragmaticplay-hot-safari",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HotSafari.webp",
    alt: "Hot Safari",
    name: "Hot Safari",
  },
  hotpepper: {
    redirectUrl: "/casino/pragmaticplay-hot-pepper",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HotPepper.webp",
    alt: "Hot Pepper",
    name: "Hot Pepper",
  },
  hotchilli: {
    redirectUrl: "/casino/pragmaticplay-hot-chilli",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HotChilli.webp",
    alt: "Hot Chilli",
    name: "Hot Chilli",
  },
  honeyhoneyhoney: {
    redirectUrl: "/casino/pragmaticplay-honey-honey-honey",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HoneyHoneyHoney.webp",
    alt: "Honey Honey Honey",
    name: "Honey Honey Honey",
  },
  holidayride: {
    redirectUrl: "/casino/pragmaticplay-holiday-ride",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HolidayRide.webp",
    alt: "Holiday Ride",
    name: "Holiday Ride",
  },
  hokkaidowolf: {
    redirectUrl: "/casino/pragmaticplay-hokkaido-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HokkaidoWolf.webp",
    alt: "Hokkaido Wolf",
    name: "Hokkaido Wolf",
  },
  hockeyleaguewildmatch: {
    redirectUrl: "/casino/pragmaticplay-hockey-league-wild-match",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HockeyLeagueWildMatch.webp",
    alt: "Hockey League Wild Match",
    name: "Hockey League Wild Match",
  },
  wavemaster: {
    redirectUrl: "/casino/pragmaticplay-wave-master",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/WaveMaster.webp",
    alt: "Wave Master",
    name: "Wave Master",
  },
  vulkanofolympus: {
    redirectUrl: "/casino/pragmaticplay-vulkan-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/vulkanofolympus.webp",
    alt: "Vulkan of Olympus",
    name: "Vulkan of Olympus",
  },
  voodoomagic: {
    redirectUrl: "/casino/pragmaticplay-voodoo-magic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VoodooMagic.webp",
    alt: "Voodoo Magic",
    name: "Voodoo Magic",
  },
  vikingsvstrolls: {
    redirectUrl: "/casino/pragmaticplay-vikings-vs-trolls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VikingsvsTrolls.webp",
    alt: "Vikings vs Trolls",
    name: "Vikings vs Trolls",
  },
  vikingforge: {
    redirectUrl: "/casino/pragmaticplay-viking-forge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VikingForge.webp",
    alt: "Viking Forge",
    name: "Viking Forge",
  },
  viadelcorso: {
    redirectUrl: "/casino/pragmaticplay-via-del-corso",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ViadelCorso.webp",
    alt: "Via del Corso",
    name: "Via del Corso",
  },
  vegasnights: {
    redirectUrl: "/casino/pragmaticplay-vegas-nights",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VegasNights.webp",
    alt: "Vegas Nights",
    name: "Vegas Nights",
  },
  vegasmagic: {
    redirectUrl: "/casino/pragmaticplay-vegas-magic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VegasMagic.webp",
    alt: "Vegas Magic",
    name: "Vegas Magic",
  },
  vegasadventures: {
    redirectUrl: "/casino/pragmaticplay-vegas-adventures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VegasAdventures.webp",
    alt: "Vegas Adventures",
    name: "Vegas Adventures",
  },
  vampiresvswolves: {
    redirectUrl: "/casino/pragmaticplay-vampires-vs-wolves",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/VampiresvsWolves.webp",
    alt: "Vampires vs Wolves",
    name: "Vampires vs Wolves",
  },
  ultraholdandspin: {
    redirectUrl: "/casino/pragmaticplay-ultra-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/UltraHoldandSpin.webp",
    alt: "Ultra Hold and Spin",
    name: "Ultra Hold and Spin",
  },
  ultraburn: {
    redirectUrl: "/casino/pragmaticplay-ultra-burn",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/UltraBurn.webp",
    alt: "Ultra Burn",
    name: "Ultra Burn",
  },
  twilightprincess: {
    redirectUrl: "/casino/pragmaticplay-twilight-princess",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TwilightPrincess.webp",
    alt: "Twilight Princess",
    name: "Twilight Princess",
  },
  tundrasfortune: {
    redirectUrl: "/casino/pragmaticplay-tundras-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TundrasFortune.webp",
    alt: "Tundras Fortune",
    name: "Tundras Fortune",
  },
  tucanito: {
    redirectUrl: "/casino/pragmaticplay-tucanito",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Tucanito.webp",
    alt: "Tucanito",
    name: "Tucanito",
  },
  tsilidoghouse: {
    redirectUrl: "/casino/pragmaticplay-tsili-dog-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TSILIDogHouse.webp",
    alt: "TSILI Dog House",
    name: "TSILI Dog House",
  },
  tropicaltiki: {
    redirectUrl: "/casino/pragmaticplay-tropical-tiki",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TropicalTiki.webp",
    alt: "Tropical Tiki",
    name: "Tropical Tiki",
  },
  tropicalpopjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-tropical-pop-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TropicalPopJackpotPlay.webp",
    alt: "Tropical Pop Jackpot Play",
    name: "Tropical Pop Jackpot Play",
  },
  trolling1000: {
    redirectUrl: "/casino/pragmaticplay-trolling-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Trolling1000.webp",
    alt: "Trolling 1000",
    name: "Trolling 1000",
  },
  tripletigers: {
    redirectUrl: "/casino/pragmaticplay-triple-tigers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TripleTigers.webp",
    alt: "Triple Tigers",
    name: "Triple Tigers",
  },
  triplepotgold: {
    redirectUrl: "/casino/pragmaticplay-triple-pot-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TriplePotGold.webp",
    alt: "Triple Pot Gold",
    name: "Triple Pot Gold",
  },
  triplejokers: {
    redirectUrl: "/casino/pragmaticplay-triple-jokers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TripleJokers.webp",
    alt: "Triple Jokers",
    name: "Triple Jokers",
  },
  tripledragons: {
    redirectUrl: "/casino/pragmaticplay-triple-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TripleDragons.webp",
    alt: "Triple Dragons",
    name: "Triple Dragons",
  },
  treesoftreasure: {
    redirectUrl: "/casino/pragmaticplay-trees-of-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TreesofTreasure.webp",
    alt: "Trees of Treasure",
    name: "Trees of Treasure",
  },
  treeofriches: {
    redirectUrl: "/casino/pragmaticplay-tree-of-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TreeofRiches.webp",
    alt: "Tree of Riches",
    name: "Tree of Riches",
  },
  treasurewild: {
    redirectUrl: "/casino/pragmaticplay-treasure-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TreasureWild.webp",
    alt: "Treasure Wild",
    name: "Treasure Wild",
  },
  treasuretrawler: {
    redirectUrl: "/casino/pragmaticplay-treasure-trawler",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TreasureTrawler.webp",
    alt: "Treasure Trawler",
    name: "Treasure Trawler",
  },
  treasurehorse: {
    redirectUrl: "/casino/pragmaticplay-treasure-horse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TreasureHors.webp",
    alt: "Treasure Horse",
    name: "Treasure Horse",
  },
  traintoseoul: {
    redirectUrl: "/casino/pragmaticplay-train-to-seoul",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TraintoSeoul.webp",
    alt: "Train to Seoul",
    name: "Train to Seoul",
  },
  toweringfortunes: {
    redirectUrl: "/casino/pragmaticplay-towering-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ToweringFortunes.webp",
    alt: "Towering Fortunes",
    name: "Towering Fortunes",
  },
  tinytoads: {
    redirectUrl: "/casino/pragmaticplay-tiny-toads",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TinyToads.webp",
    alt: "Tiny Toads",
    name: "Tiny Toads",
  },
  timberstacks: {
    redirectUrl: "/casino/pragmaticplay-timber-stacks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TimberStacks.webp",
    alt: "Timber Stacks",
    name: "Timber Stacks",
  },
  tigresortudo: {
    redirectUrl: "/casino/pragmaticplay-tigre-sortudo",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TigreSortudo.webp",
    alt: "Tigre Sortudo",
    name: "Tigre Sortudo",
  },
  tictactake: {
    redirectUrl: "/casino/pragmaticplay-tic-tac-take",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TicTacTake.webp",
    alt: "Tic Tac Take",
    name: "Tic Tac Take",
  },
  thundervsunderworld: {
    redirectUrl: "/casino/pragmaticplay-thunder-vs-underworld",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ThundervsUnderworld.webp",
    alt: "Thunder vs Underworld",
    name: "Thunder vs Underworld",
  },
  threestarfortune: {
    redirectUrl: "/casino/pragmaticplay-three-star-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ThreeStarFortune.webp",
    alt: "Three Star Fortune",
    name: "Three Star Fortune",
  },
  thewildgang: {
    redirectUrl: "/casino/pragmaticplay-the-wild-gang",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheWildGang.webp",
    alt: "The Wild Gang",
    name: "The Wild Gang",
  },
  theultimate5: {
    redirectUrl: "/casino/pragmaticplay-the-ultimate-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheUltimate5.webp",
    alt: "The Ultimate 5",
    name: "The Ultimate 5",
  },
  thetweetyhouse: {
    redirectUrl: "/casino/pragmaticplay-the-tweety-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheTweetyHouse.webp",
    alt: "The Tweety House",
    name: "The Tweety House",
  },
  thetigerwarrior: {
    redirectUrl: "/casino/pragmaticplay-the-tiger-warrior",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheTigerWarrior.webp",
    alt: "The Tiger Warrior",
    name: "The Tiger Warrior",
  },
  theroohouse: {
    redirectUrl: "/casino/pragmaticplay-the-roo-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheRooHouse.webp",
    alt: "The Roo House",
    name: "The Roo House",
  },
  theredqueen: {
    redirectUrl: "/casino/pragmaticplay-the-red-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheRedQueen.webp",
    alt: "The Red Queen",
    name: "The Red Queen",
  },
  themoneymenmegaways: {
    redirectUrl: "/casino/pragmaticplay-the-money-men-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheMoneyMenMegaways.webp",
    alt: "The Money Men Megaways",
    name: "The Money Men Megaways",
  },
  themagiccauldronenchantedbrew: {
    redirectUrl: "/casino/pragmaticplay-the-magic-cauldron-enchanted-brew",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheMagicCauldronEnchantedBrew.webp",
    alt: "The Magic Cauldron  Enchanted Brew",
    name: "The Magic Cauldron  Enchanted Brew",
  },
  theknightking: {
    redirectUrl: "/casino/pragmaticplay-the-knight-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/KnightKing.webp",
    alt: "The Knight King",
    name: "The Knight King",
  },
  thehandofmidas: {
    redirectUrl: "/casino/pragmaticplay-the-hand-of-midas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheHandofMidas.webp",
    alt: "The Hand of Midas",
    name: "The Hand of Midas",
  },
  thegreensun: {
    redirectUrl: "/casino/pragmaticplay-the-green-sun",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheGreenSun.webp",
    alt: "The Green Sun",
    name: "The Green Sun",
  },
  thegreatstickup: {
    redirectUrl: "/casino/pragmaticplay-the-great-stick-up",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheGreatStickUp.webp",
    alt: "The Great Stick-Up",
    name: "The Great Stick-Up",
  },
  thegreatchickenescape: {
    redirectUrl: "/casino/pragmaticplay-the-great-chicken-escape",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheGreatChickenEscape.webp",
    alt: "The Great Chicken Escape",
    name: "The Great Chicken Escape",
  },
  thedragontiger: {
    redirectUrl: "/casino/pragmaticplay-the-dragon-tiger",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDragonTiger.webp",
    alt: "The Dragon Tiger",
    name: "The Dragon Tiger",
  },
  thedoghousemultihold: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-multihold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseMultihold.webp",
    alt: "The Dog House Multihold",
    name: "The Dog House Multihold",
  },
  thedoghousemegaways: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseMegaways.webp",
    alt: "The Dog House Megaways",
    name: "The Dog House Megaways",
  },
  thedoghousediceshow: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-dice-show",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseDiceShow.webp",
    alt: "The Dog House Dice Show",
    name: "The Dog House Dice Show",
  },
  thedoghouseroyalhunt: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-royal-hunt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseRoyalHunt.webp",
    alt: "The Dog House – Royal Hunt",
    name: "The Dog House – Royal Hunt",
  },
  thedoghousemuttleycrew: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-muttley-crew",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseMuttleyCrew.webp",
    alt: "The Dog House - Muttley Crew",
    name: "The Dog House - Muttley Crew",
  },
  thedoghousedogoralive: {
    redirectUrl: "/casino/pragmaticplay-the-dog-house-dog-or-alive",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheDogHouseDogorAlive.webp",
    alt: "The Dog House - Dog or Alive",
    name: "The Dog House - Dog or Alive",
  },

  thecatfatherpartii: {
    redirectUrl: "/casino/pragmaticplay-the-catfather-part-ii",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheCatfatherPartII.webp",
    alt: "The Catfather Part II",
    name: "The Catfather Part II",
  },
  thecatfather: {
    redirectUrl: "/casino/pragmaticplay-the-catfather",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheCatfather.webp",
    alt: "The Catfather",
    name: "The Catfather",
  },
  thebirdhouse: {
    redirectUrl: "/casino/pragmaticplay-the-bird-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheBirdHouse.webp",
    alt: "The Bird House",
    name: "The Bird House",
  },
  thebigdawgs: {
    redirectUrl: "/casino/pragmaticplay-the-big-dawgs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheBigDawgs.webp",
    alt: "The Big Dawgs",
    name: "The Big Dawgs",
  },
  theamazingmoneymachine: {
    redirectUrl: "/casino/pragmaticplay-the-amazing-money-machine",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheAmazingMoneyMachine.webp",
    alt: "The Amazing Money Machine",
    name: "The Amazing Money Machine",
  },
  thealterego: {
    redirectUrl: "/casino/pragmaticplay-the-alter-ego",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TheAlterEgo.webp",
    alt: "The Alter Ego",
    name: "The Alter Ego",
  },
  temujintreasures: {
    redirectUrl: "/casino/pragmaticplay-temujin-treasures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TemujinTreasures.webp",
    alt: "Temujin Treasures",
    name: "Temujin Treasures",
  },
  templeguardians: {
    redirectUrl: "/casino/pragmaticplay-temple-guardians",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TempleGuardians.webp",
    alt: "Temple Guardians",
    name: "Temple Guardians",
  },
  talesofegypt: {
    redirectUrl: "/casino/pragmaticplay-tales-of-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/TalesofEgypt.webp",
    alt: "Tales of Egypt",
    name: "Tales of Egypt",
  },
  swordofares: {
    redirectUrl: "/casino/pragmaticplay-sword-of-ares",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SwordofAres.webp",
    alt: "Sword of Ares",
    name: "Sword of Ares",
  },
  sweetpowernudge: {
    redirectUrl: "/casino/pragmaticplay-sweet-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetPowerNudge.webp",
    alt: "Sweet PowerNudge",
    name: "Sweet PowerNudge",
  },
  firebirdspirit: {
    redirectUrl: "/casino/pragmaticplay-firebird-spirit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FirebirdSpirit.webp",
    alt: "Firebird Spirit",
    name: "Firebird Spirit",
  },
  sweetkingdom: {
    redirectUrl: "/casino/pragmaticplay-sweet-kingdom",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetKingdom.webp",
    alt: "Sweet Kingdom",
    name: "Sweet Kingdom",
  },
  sweetfiesta: {
    redirectUrl: "/casino/pragmaticplay-sweet-fiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetFiesta.webp",
    alt: "Sweet Fiesta",
    name: "Sweet Fiesta",
  },
  sweetbonanzaxmas: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza-xmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanzaXmas.webp",
    alt: "Sweet Bonanza Xmas",
    name: "Sweet Bonanza Xmas",
  },
  sweetbonanzasuperscatter: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanzaSuperScatter.webp",
    alt: "Sweet Bonanza Super Scatter",
    name: "Sweet Bonanza Super Scatter",
  },
  sweetbonanzadice: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanza.webp",
    alt: "Sweet Bonanza Dice",
    name: "Sweet Bonanza Dice",
  },
  sweetbonanzadice: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza-1000-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanza1000Dice.webp",
    alt: "Sweet Bonanza 1000 Dice",
    name: "Sweet Bonanza 1000 Dice",
  },
  sweetbonanza1000: {
    redirectUrl: "/casino/pragmaticplay-sweet-bonanza-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBonanza1000.webp",
    alt: "Sweet Bonanza 1000",
    name: "Sweet Bonanza 1000",
  },

  sweetbombdrop: {
    redirectUrl: "/casino/pragmaticplay-sweet-bomb-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBombDrop.webp",
    alt: "Sweet Bomb Drop",
    name: "Sweet Bomb Drop",
  },
  sweetbaklava: {
    redirectUrl: "/casino/pragmaticplay-sweet-baklava",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SweetBaklava.webp",
    alt: "Sweet Baklava",
    name: "Sweet Baklava",
  },
  supermania: {
    redirectUrl: "/casino/pragmaticplay-supermania",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Supermania.webp",
    alt: "Supermania",
    name: "Supermania",
  },
  superligaheroes: {
    redirectUrl: "/casino/pragmaticplay-superliga-heroes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SuperligaHeroes.webp",
    alt: "Superliga Heroes",
    name: "Superliga Heroes",
  },
  superx: {
    redirectUrl: "/casino/pragmaticplay-super-x",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SuperX.webp",
    alt: "Super X",
    name: "Super X",
  },
  superjoker: {
    redirectUrl: "/casino/pragmaticplay-super-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SuperJoker.webp",
    alt: "Super Joker",
    name: "Super Joker",
  },
  super7s: {
    redirectUrl: "/casino/pragmaticplay-super-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Super7s.webp",
    alt: "Super 7s",
    name: "Super 7s",
  },
  sunstonejewels: {
    redirectUrl: "/casino/pragmaticplay-sunstone-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SunstoneJewels.webp",
    alt: "Sunstone Jewels",
    name: "Sunstone Jewels",
  },
  sumosuprememegaways: {
    redirectUrl: "/casino/pragmaticplay-sumo-supreme-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SumoSupremeMegaways.webp",
    alt: "Sumo Supreme Megaways",
    name: "Sumo Supreme Megaways",
  },
  sugartwist: {
    redirectUrl: "/casino/pragmaticplay-sugar-twist",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarTwist.webp",
    alt: "Sugar Twist",
    name: "Sugar Twist",
  },
  sugarsupremepowernudge: {
    redirectUrl: "/casino/pragmaticplay-sugar-supreme-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarSupremePowernudge.webp",
    alt: "Sugar Supreme Powernudge",
    name: "Sugar Supreme Powernudge",
  },
  sugarrushxmas: {
    redirectUrl: "/casino/pragmaticplay-sugar-rush-xmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarRushXmas.webp",
    alt: "Sugar Rush Xmas",
    name: "Sugar Rush Xmas",
  },
  sugarrushdice: {
    redirectUrl: "/casino/pragmaticplay-sugar-rush-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarRushDice.webp",
    alt: "Sugar Rush Dice",
    name: "Sugar Rush Dice",
  },
  sugarrush1000: {
    redirectUrl: "/casino/pragmaticplay-sugar-rush-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SugarRush1000.webp",
    alt: "Sugar Rush 1000",
    name: "Sugar Rush 1000",
  },

  strikinghot5jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-striking-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StrikingHot5JackpotPlay.webp",
    alt: "Striking Hot 5 Jackpot Play",
    name: "Striking Hot 5 Jackpot Play",
  },
  strikinghot5: {
    redirectUrl: "/casino/pragmaticplay-striking-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StrikingHot5.webp",
    alt: "Striking Hot 5",
    name: "Striking Hot 5",
  },
  strikefrenzy: {
    redirectUrl: "/casino/pragmaticplay-strike-frenzy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StrikeFrenzy.webp",
    alt: "Strike Frenzy",
    name: "Strike Frenzy",
  },
  streetracer: {
    redirectUrl: "/casino/pragmaticplay-street-racer",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StreetRacer.webp",
    alt: "Street Racer",
    name: "Street Racer",
  },
  strawberrycocktail: {
    redirectUrl: "/casino/pragmaticplay-strawberry-cocktail",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StrawberryCocktail.webp",
    alt: "Strawberry Cocktail",
    name: "Strawberry Cocktail",
  },
  stickybees: {
    redirectUrl: "/casino/pragmaticplay-sticky-bees",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StickyBees.webp",
    alt: "Sticky Bees",
    name: "Sticky Bees",
  },
  starzmegaways: {
    redirectUrl: "/casino/pragmaticplay-starz-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarzMegaways.webp",
    alt: "Starz Megaways",
    name: "Starz Megaways",
  },
  starlightprincesspachi: {
    redirectUrl: "/casino/pragmaticplay-starlight-princess-pachi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarlightPrincessPachi.webp",
    alt: "Starlight Princess Pachi",
    name: "Starlight Princess Pachi",
  },
  starlightprincess1000: {
    redirectUrl: "/casino/pragmaticplay-starlight-princess-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarlightPrincess1000.webp",
    alt: "Starlight Princess 1000",
    name: "Starlight Princess 1000",
  },
  starlightprincess: {
    redirectUrl: "/casino/pragmaticplay-starlight-princess",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarlightPrincess.webp",
    alt: "Starlight Princess",
    name: "Starlight Princess",
  },
  starlightchristmas: {
    redirectUrl: "/casino/pragmaticplay-starlight-christmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarlightChristmas.webp",
    alt: "Starlight Christmas",
    name: "Starlight Christmas",
  },
  starpiratescode: {
    redirectUrl: "/casino/pragmaticplay-star-pirates-code",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarPiratesCode.webp",
    alt: "Star Pirates Code",
    name: "Star Pirates Code",
  },
  starbounty: {
    redirectUrl: "/casino/pragmaticplay-star-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/StarBounty.webp",
    alt: "Star Bounty",
    name: "Star Bounty",
  },
  spinscoremegaways: {
    redirectUrl: "/casino/pragmaticplay-spin-and-score-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Spin&ScoreMegaways.webp",
    alt: "Spin & Score Megaways",
    name: "Spin & Score Megaways",
  },
  spellbindingmystery: {
    redirectUrl: "/casino/pragmaticplay-spellbinding-mystery",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SpellbindingMystery.webp",
    alt: "Spellbinding Mystery",
    name: "Spellbinding Mystery",
  },
  spartanking: {
    redirectUrl: "/casino/pragmaticplay-spartan-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SpartanKing.webp",
    alt: "Spartan King",
    name: "Spartan King",
  },
  snakesandladdersmegadice: {
    redirectUrl: "/casino/pragmaticplay-snakes-and-ladders-megadice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SnakesandLaddersMegadice.webp",
    alt: "Snakes and Ladders Megadice",
    name: "Snakes and Ladders Megadice",
  },
  snakesladderssnakeeyes: {
    redirectUrl: "/casino/pragmaticplay-snakes-and-ladders-snake-eyes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Snakes&LaddersSnakeEyes.webp",
    alt: "Snakes & Ladders - Snake Eyes",
    name: "Snakes & Ladders - Snake Eyes",
  },
  smugglerscove: {
    redirectUrl: "/casino/pragmaticplay-smugglers-cove",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SmugglersCove.webp",
    alt: "Smugglers Cove",
    name: "Smugglers Cove",
  },
  slushieparty: {
    redirectUrl: "/casino/pragmaticplay-slushie-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SlushieParty.webp",
    alt: "Slushie Party",
    name: "Slushie Party",
  },
  slotmaniarabbit: {
    redirectUrl: "/casino/pragmaticplay-slot-mania-rabbit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SlotManiaRabbit.webp",
    alt: "Slot Mania Rabbit",
    name: "Slot Mania Rabbit",
  },
  sleepingdragon: {
    redirectUrl: "/casino/pragmaticplay-sleeping-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SleepingDragon.webp",
    alt: "Sleeping Dragon",
    name: "Sleeping Dragon",
  },
  skybounty: {
    redirectUrl: "/casino/pragmaticplay-sky-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SkyBounty.webp",
    alt: "Sky Bounty",
    name: "Sky Bounty",
  },
  shotsforslots: {
    redirectUrl: "/casino/pragmaticplay-shots-for-slots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/shotsforslots.webp",
    alt: "Shots for Slots",
    name: "Shots for Slots",
  },
  shininghot5jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot5JackpotPlay.webp",
    alt: "Shining Hot 5 Jackpot Play",
    name: "Shining Hot 5 Jackpot Play",
  },
  shininghot5: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot5.webp",
    alt: "Shining Hot 5",
    name: "Shining Hot 5",
  },
  shininghot40jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-40-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot40JackpotPlay.webp",
    alt: "Shining Hot 40 Jackpot Play",
    name: "Shining Hot 40 Jackpot Play",
  },
  shininghot40: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-40",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot40.webp",
    alt: "Shining Hot 40",
    name: "Shining Hot 40",
  },
  shininghot20jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-20-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot20Jackpotplay.webp",
    alt: "Shining Hot 20 Jackpot play",
    name: "Shining Hot 20 Jackpot play",
  },
  shininghot20: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-20",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot20.webp",
    alt: "Shining Hot 20",
    name: "Shining Hot 20",
  },
  shininghot100jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-100-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot100JackpotPlay.webp",
    alt: "Shining Hot 100 Jackpot Play",
    name: "Shining Hot 100 Jackpot Play",
  },
  shininghot100: {
    redirectUrl: "/casino/pragmaticplay-shining-hot-100",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShiningHot100.webp",
    alt: "Shining Hot 100",
    name: "Shining Hot 100",
  },
  shieldofsparta: {
    redirectUrl: "/casino/pragmaticplay-shield-of-sparta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ShieldofSparta.webp",
    alt: "Shield of Sparta",
    name: "Shield of Sparta",
  },
  secretcitygold: {
    redirectUrl: "/casino/pragmaticplay-secret-city-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SecretCityGold.webp",
    alt: "Secret City Gold",
    name: "Secret City Gold",
  },
  savannahlegend: {
    redirectUrl: "/casino/pragmaticplay-savannah-legend",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SavannahLegend.webp",
    alt: "Savannah Legend",
    name: "Savannah Legend",
  },
  sasuntsidavit: {
    redirectUrl: "/casino/pragmaticplay-sasuntsi-davit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SasuntsiDavit.webp",
    alt: "Sasuntsi Davit",
    name: "Sasuntsi Davit",
  },
  sarayruyasi: {
    redirectUrl: "/casino/pragmaticplay-saray-ruyasi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SarayRuyasi.webp",
    alt: "Saray Ruyasi",
    name: "Saray Ruyasi",
  },
  santasxmasrush: {
    redirectUrl: "/casino/pragmaticplay-santas-xmas-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SantasXmasRush.webp",
    alt: "Santas Xmas Rush",
    name: "Santas Xmas Rush",
  },
  SeaFantasy: {
    redirectUrl: "/casino/pragmaticplay-sea-fantasy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SeaFantasy.webp",
    alt: "Sea Fantasy",
    name: "Sea Fantasy",
  },
  santaswonderland: {
    redirectUrl: "/casino/pragmaticplay-santas-wonderland",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SantasWonderland.webp",
    alt: "Santas Wonderland",
    name: "Santas Wonderland",
  },
  santasgreatgifts: {
    redirectUrl: "/casino/pragmaticplay-santas-great-gifts",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SantasGreatGifts.webp",
    alt: "Santa’s Great Gifts",
    name: "Santa’s Great Gifts",
  },
  santa: {
    redirectUrl: "/casino/pragmaticplay-santa",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Santa.webp",
    alt: "Santa",
    name: "Santa",
  },
  samuraicode: {
    redirectUrl: "/casino/pragmaticplay-samurai-code",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SamuraiCode.webp",
    alt: "Samurai Code",
    name: "Samurai Code",
  },
  saiyanmania: {
    redirectUrl: "/casino/pragmaticplay-saiyan-mania",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SaiyanMania.webp",
    alt: "Saiyan Mania",
    name: "Saiyan Mania",
  },
  safariking: {
    redirectUrl: "/casino/pragmaticplay-safari-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SafariKing.webp",
    alt: "Safari King",
    name: "Safari King",
  },
  sabafufufu: {
    redirectUrl: "/casino/pragmaticplay-saba-fu-fu-fu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/SabaFuFuFu.webp",
    alt: "Saba Fu Fu Fu",
    name: "Saba Fu Fu Fu",
  },
  runningsushi: {
    redirectUrl: "/casino/pragmaticplay-running-sushi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RunningSushi.webp",
    alt: "Running Sushi",
    name: "Running Sushi",
  },
  runaway7s: {
    redirectUrl: "/casino/pragmaticplay-runaway-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Runaway7s.webp",
    alt: "Runaway 7s",
    name: "Runaway 7s",
  },
  rujakbonanza: {
    redirectUrl: "/casino/pragmaticplay-rujak-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RujakBonanza.webp",
    alt: "Rujak Bonanza",
    name: "Rujak Bonanza",
  },
  romeoandjuliet: {
    redirectUrl: "/casino/pragmaticplay-romeo-and-juliet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RomeoandJuliet.webp",
    alt: "Romeo and Juliet",
    name: "Romeo and Juliet",
  },
  rockvegasmegaholdspin: {
    redirectUrl: "/casino/pragmaticplay-rock-vegas-mega-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RockVegasMegaHold&Spin.webp",
    alt: "Rock Vegas Mega Hold & Spin",
    name: "Rock Vegas Mega Hold & Spin",
  },
  robberstrike: {
    redirectUrl: "/casino/pragmaticplay-robber-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RobberStrike.webp",
    alt: "Robber Strike",
    name: "Robber Strike",
  },
  riverofstyx: {
    redirectUrl: "/casino/pragmaticplay-river-of-styx",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiverofStyx.webp",
    alt: "River of Styx",
    name: "River of Styx",
  },
  riseofsamuraimegaways: {
    redirectUrl: "/casino/pragmaticplay-rise-of-samurai-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofSamuraiMegaways.webp",
    alt: "Rise of Samurai Megaways",
    name: "Rise of Samurai Megaways",
  },
  riseofsamurai4: {
    redirectUrl: "/casino/pragmaticplay-rise-of-samurai-4",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofSamurai4.webp",
    alt: "Rise of Samurai 4",
    name: "Rise of Samurai 4",
  },
  riseofsamurai3: {
    redirectUrl: "/casino/pragmaticplay-rise-of-samurai-3",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofSamurai3.webp",
    alt: "Rise of Samurai 3",
    name: "Rise of Samurai 3",
  },
  riseofsamurai: {
    redirectUrl: "/casino/pragmaticplay-rise-of-samurai",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofSamurai.webp",
    alt: "Rise of Samurai",
    name: "Rise of Samurai",
  },
  riseofpyramids: {
    redirectUrl: "/casino/pragmaticplay-rise-of-pyramids",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofPyramids.webp",
    alt: "Rise of Pyramids",
    name: "Rise of Pyramids",
  },
  riseofgizapowernudge: {
    redirectUrl: "/casino/pragmaticplay-rise-of-giza-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RiseofGizaPowerNudge.webp",
    alt: "Rise of Giza PowerNudge",
    name: "Rise of Giza PowerNudge",
  },
  riperewards: {
    redirectUrl: "/casino/pragmaticplay-ripe-rewards",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RipeRewards.webp",
    alt: "Ripe Rewards",
    name: "Ripe Rewards",
  },
  ridethelightning: {
    redirectUrl: "/casino/pragmaticplay-ride-the-lightning",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RideTheLightning.webp",
    alt: "Ride The Lightning",
    name: "Ride The Lightning",
  },
  revengeoflokimegaways: {
    redirectUrl: "/casino/pragmaticplay-revenge-of-loki-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RevengeofLokiMegaways.webp",
    alt: "Revenge of Loki Megaways",
    name: "Revenge of Loki Megaways",
  },
  returnofthedead: {
    redirectUrl: "/casino/pragmaticplay-return-of-the-dead",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ReturnoftheDead.webp",
    alt: "Return of the Dead",
    name: "Return of the Dead",
  },
  resurrectingriches: {
    redirectUrl: "/casino/pragmaticplay-resurrecting-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ResurrectingRiches.webp",
    alt: "Resurrecting Riches",
    name: "Resurrecting Riches",
  },
  releasethekraken: {
    redirectUrl: "/casino/pragmaticplay-release-the-kraken",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ReleasetheKraken.webp",
    alt: "Release the Kraken",
    name: "Release the Kraken",
  },
  releasethebison: {
    redirectUrl: "/casino/pragmaticplay-release-the-bison",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ReleasetheBison.webp",
    alt: "Release the Bison",
    name: "Release the Bison",
  },
  reelbanks: {
    redirectUrl: "/casino/pragmaticplay-reel-banks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ReelBanks.webp",
    alt: "Reel Banks",
    name: "Reel Banks",
  },
  redhotluck: {
    redirectUrl: "/casino/pragmaticplay-red-hot-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RedHotLuck.webp",
    alt: "Red Hot Luck",
    name: "Red Hot Luck",
  },
  rainbowreels: {
    redirectUrl: "/casino/pragmaticplay-rainbow-reels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RainbowReels.webp",
    alt: "Rainbow Reels",
    name: "Rainbow Reels",
  },
  rainbowgold: {
    redirectUrl: "/casino/pragmaticplay-rainbow-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RainbowGold.webp",
    alt: "Rainbow Gold",
    name: "Rainbow Gold",
  },
  ragingwaterfallmegaways: {
    redirectUrl: "/casino/pragmaticplay-raging-waterfall-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RagingWaterfallMegaways.webp",
    alt: "Raging Waterfall Megaways™",
    name: "Raging Waterfall Megaways™",
  },
  ragingbull: {
    redirectUrl: "/casino/pragmaticplay-raging-bull",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RagingBull.webp",
    alt: "Raging Bull",
    name: "Raging Bull",
  },
  racingjoker: {
    redirectUrl: "/casino/pragmaticplay-racing-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RacingJoker.webp",
    alt: "Racing Joker",
    name: "Racing Joker",
  },
  rabbitgarden: {
    redirectUrl: "/casino/pragmaticplay-rabbit-garden",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/RabbitGarden.webp",
    alt: "Rabbit Garden",
    name: "Rabbit Garden",
  },
  queenie: {
    redirectUrl: "/casino/pragmaticplay-queenie",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Queenie.webp",
    alt: "Queenie",
    name: "Queenie",
  },
  queenofgold: {
    redirectUrl: "/casino/pragmaticplay-queen-of-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/QueenofGold.webp",
    alt: "Queen of Gold",
    name: "Queen of Gold",
  },
  queenofgods: {
    redirectUrl: "/casino/pragmaticplay-queen-of-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/QueenofGods.webp",
    alt: "Queen of Gods",
    name: "Queen of Gods",
  },
  pyramidking: {
    redirectUrl: "/casino/pragmaticplay-pyramid-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PyramidKing.webp",
    alt: "Pyramid King",
    name: "Pyramid King",
  },
  pyramidbonanza: {
    redirectUrl: "/casino/pragmaticplay-pyramid-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PyramidBonanza.webp",
    alt: "Pyramid Bonanza",
    name: "Pyramid Bonanza",
  },
  puresweet: {
    redirectUrl: "/casino/pragmaticplay-pure-sweet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/puresweet.webp",
    alt: "Pure Sweet",
    name: "Pure Sweet",
  },
  purefruit: {
    redirectUrl: "/casino/pragmaticplay-pure-fruit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PureFruit.webp",
    alt: "Pure Fruit",
    name: "Pure Fruit",
  },
  puffersvssharks: {
    redirectUrl: "/casino/pragmaticplay-puffers-vs-sharks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PuffersvsSharks.webp",
    alt: "Puffers vs Sharks",
    name: "Puffers vs Sharks",
  },
  pubkings: {
    redirectUrl: "/casino/pragmaticplay-pub-kings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PubKings.webp",
    alt: "Pub Kings",
    name: "Pub Kings",
  },
  powerofthormegaways: {
    redirectUrl: "/casino/pragmaticplay-power-of-thor-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PowerofThorMegaways.webp",
    alt: "Power of Thor Megaways",
    name: "Power of Thor Megaways",
  },
  powerofninja: {
    redirectUrl: "/casino/pragmaticplay-power-of-ninja",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PowerofNinja.webp",
    alt: "Power of Ninja",
    name: "Power of Ninja",
  },
  potoffortune: {
    redirectUrl: "/casino/pragmaticplay-pot-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PotofFortune.webp",
    alt: "Pot of Fortune",
    name: "Pot of Fortune",
  },
  pompeiimegareelsmegaways: {
    redirectUrl: "/casino/pragmaticplay-pompeii-megareels-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PompeiiMegareelsMegaways.webp",
    alt: "Pompeii Megareels Megaways",
    name: "Pompeii Megareels Megaways",
  },
  pizzapizzapizza: {
    redirectUrl: "/casino/pragmaticplay-pizza-pizza-pizza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PIZZAPIZZAPIZZA.webp",
    alt: "PIZZA PIZZA PIZZA",
    name: "PIZZA PIZZA PIZZA",
  },
  pixiewings: {
    redirectUrl: "/casino/pragmaticplay-pixie-wings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PixieWings.webp",
    alt: "Pixie Wings",
    name: "Pixie Wings",
  },
  piratespub: {
    redirectUrl: "/casino/pragmaticplay-pirates-pub",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PiratesPub.webp",
    alt: "Pirates Pub",
    name: "Pirates Pub",
  },
  piratequest1000: {
    redirectUrl: "/casino/pragmaticplay-pirate-quest-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PirateQuest1000.webp",
    alt: "Pirate Quest 1000",
    name: "Pirate Quest 1000",
  },
  pirategoldenage: {
    redirectUrl: "/casino/pragmaticplay-pirate-golden-age",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PirateGoldenAge.webp",
    alt: "Pirate Golden Age",
    name: "Pirate Golden Age",
  },
  pirategolddeluxe: {
    redirectUrl: "/casino/pragmaticplay-pirate-gold-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PirateGoldDeluxe.webp",
    alt: "Pirate Gold Deluxe",
    name: "Pirate Gold Deluxe",
  },
  pirategold: {
    redirectUrl: "/casino/pragmaticplay-pirate-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PirateGold.webp",
    alt: "Pirate Gold",
    name: "Pirate Gold",
  },
  pinupgirls: {
    redirectUrl: "/casino/pragmaticplay-pinup-girls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PinupGirls.webp",
    alt: "Pinup Girls",
    name: "Pinup Girls",
  },
  piggyrockparty: {
    redirectUrl: "/casino/pragmaticplay-piggy-rock-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PiggyRockParty.webp",
    alt: "Piggy Rock Party",
    name: "Piggy Rock Party",
  },
  piggybankers: {
    redirectUrl: "/casino/pragmaticplay-piggy-bankers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PiggyBankers.webp",
    alt: "Piggy Bankers",
    name: "Piggy Bankers",
  },
  piggybankbills: {
    redirectUrl: "/casino/pragmaticplay-piggy-bank-bills",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PiggyBankBills.webp",
    alt: "Piggy Bank Bills",
    name: "Piggy Bank Bills",
  },
  phoenixforge: {
    redirectUrl: "/casino/pragmaticplay-phoenix-forge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PhoenixForge.webp",
    alt: "Phoenix Forge",
    name: "Phoenix Forge",
  },
  peppespepperonipizzaplaza: {
    redirectUrl: "/casino/pragmaticplay-peppes-pepperoni-pizza-plaza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PeppesPepperoniPizzaPlaza.webp",
    alt: "Peppes Pepperoni Pizza Plaza",
    name: "Peppes Pepperoni Pizza Plaza",
  },
  penguinschristmaspartytime: {
    redirectUrl: "/casino/pragmaticplay-penguins-christmas-party-time",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PenguinsChristmasPartyTime.webp",
    alt: "Penguins Christmas Party Time",
    name: "Penguins Christmas Party Time",
  },
  pekingluck: {
    redirectUrl: "/casino/pragmaticplay-peking-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PekingLuck.webp",
    alt: "Peking Luck",
    name: "Peking Luck",
  },
  peakpower: {
    redirectUrl: "/casino/pragmaticplay-peak-power",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PeakPower.webp",
    alt: "Peak Power",
    name: "Peak Power",
  },
  pantherqueen: {
    redirectUrl: "/casino/pragmaticplay-panther-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PantherQueen.webp",
    alt: "Panther Queen",
    name: "Panther Queen",
  },
  pandafortune2: {
    redirectUrl: "/casino/pragmaticplay-panda-fortune-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PandaFortune2.webp",
    alt: "Panda Fortune 2",
    name: "Panda Fortune 2",
  },
  pandafortune: {
    redirectUrl: "/casino/pragmaticplay-panda-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/PandaFortune.webp",
    alt: "Panda Fortune",
    name: "Panda Fortune",
  },
  oodlesofnoodles: {
    redirectUrl: "/casino/pragmaticplay-oodles-of-noodles",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/OodlesofNoodles.webp",
    alt: "Oodles of Noodles",
    name: "Oodles of Noodles",
  },
  oly: {
    redirectUrl: "/casino/pragmaticplay-oly",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/oly.webp",
    alt: "Oly",
    name: "Oly",
  },
  oldgoldminermegaways: {
    redirectUrl: "/casino/pragmaticplay-old-gold-miner-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/OldGoldMinerMegaways.webp",
    alt: "Old Gold Miner Megaways",
    name: "Old Gold Miner Megaways",
  },
  oishiibonanza: {
    redirectUrl: "/casino/pragmaticplay-oishii-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/OishiiBonanza.webp",
    alt: "Oishii Bonanza",
    name: "Oishii Bonanza",
  },
  octobeerfortunes: {
    redirectUrl: "/casino/pragmaticplay-octobeer-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/OctobeerFortunes.webp",
    alt: "Octobeer Fortunes",
    name: "Octobeer Fortunes",
  },
  northguardians: {
    redirectUrl: "/casino/pragmaticplay-north-guardians",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/NorthGuardians.webp",
    alt: "North Guardians",
    name: "North Guardians",
  },
  nilefortunes: {
    redirectUrl: "/casino/pragmaticplay-nile-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/NileFortunes.webp",
    alt: "Nile Fortunes",
    name: "Nile Fortunes",
  },
  nexusgatesofolympus: {
    redirectUrl: "/casino/pragmaticplay-nexus-gates-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/nexusgatesofolympus.webp",
    alt: "Nexus Gates of Olympus",
    name: "Nexus Gates of Olympus",
  },
  newyeartigertreasures: {
    redirectUrl: "/casino/pragmaticplay-new-year-tiger-treasures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/NewYearTigerTreasures.webp",
    alt: "New Year Tiger Treasures",
    name: "New Year Tiger Treasures",
  },
  newtalesofegypt: {
    redirectUrl: "/casino/pragmaticplay-new-tales-of-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/NewTalesofEgypt.webp",
    alt: "New Tales of Egypt",
    name: "New Tales of Egypt",
  },
  mysticchief: {
    redirectUrl: "/casino/pragmaticplay-mystic-chief",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MysticChief.webp",
    alt: "Mystic Chief",
    name: "Mystic Chief",
  },
  mysteryoftheorient: {
    redirectUrl: "/casino/pragmaticplay-mystery-of-the-orient",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/mysteryoftheorient.jpg",
    alt: "Mystery of the Orient",
    name: "Mystery of the Orient",
  },
  mysterymice: {
    redirectUrl: "/casino/pragmaticplay-mystery-mice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MysteryMice.webp",
    alt: "Mystery Mice",
    name: "Mystery Mice",
  },
  mysteriousegypt: {
    redirectUrl: "/casino/pragmaticplay-mysterious-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MysteriousEgypt.webp",
    alt: "Mysterious Egypt",
    name: "Mysterious Egypt",
  },
  mustangtrail: {
    redirectUrl: "/casino/pragmaticplay-mustang-trail",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MustangTrail.webp",
    alt: "Mustang Trail",
    name: "Mustang Trail",
  },
  mustanggold: {
    redirectUrl: "/casino/pragmaticplay-mustang-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MustangGold.webp",
    alt: "Mustang Gold",
    name: "Mustang Gold",
  },
  mummysjewels: {
    redirectUrl: "/casino/pragmaticplay-mummys-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MummysJewel.webp",
    alt: "Mummy's Jewels",
    name: "Mummy's Jewels",
  },
  muertosmultipliermegaways: {
    redirectUrl: "/casino/pragmaticplay-muertos-multiplier-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MuertosMultiplierMegaways.webp",
    alt: "Muertos Multiplier Megaways",
    name: "Muertos Multiplier Megaways",
  },
  mrtainsfurywildwildgladiator: {
    redirectUrl: "/casino/pragmaticplay-mr-tains-fury-wild-wild-gladiator",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MrTainsFuryWildWildGladiator.webp",
    alt: "Mr Tain's Fury: Wild Wild Gladiator",
    name: "Mr Tain's Fury: Wild Wild Gladiator",
  },
  mrtainsfishingadventures: {
    redirectUrl: "/casino/pragmaticplay-mr-tains-fishing-adventures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MrTainsFishingAdventures.webp",
    alt: "Mr Tains Fishing Adventures",
    name: "Mr Tains Fishing Adventures",
  },
  mpoplayaztecgems: {
    redirectUrl: "/casino/pragmaticplay-mpoplay-aztec-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MPOPLAYAztecGems.webp",
    alt: "MPOPLAY Aztec Gems",
    name: "MPOPLAY Aztec Gems",
  },
  moonshot: {
    redirectUrl: "/casino/pragmaticplay-moonshot",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Moonshot.webp",
    alt: "Moonshot",
    name: "Moonshot",
  },
  monstersuperlanche: {
    redirectUrl: "/casino/pragmaticplay-monster-superlanche",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MonsterSuperlanche.webp",
    alt: "Monster Superlanche",
    name: "Monster Superlanche",
  },
  monkeywarrior: {
    redirectUrl: "/casino/pragmaticplay-monkey-warrior",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MonkeyWarrior.webp",
    alt: "Monkey Warrior",
    name: "Monkey Warrior",
  },
  monkeymadness: {
    redirectUrl: "/casino/pragmaticplay-monkey-madness",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MonkeyMadness.webp",
    alt: "Monkey Madness",
    name: "Monkey Madness",
  },
  moneystacks: {
    redirectUrl: "/casino/pragmaticplay-money-stacks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MoneyStacks.webp",
    alt: "Money Stacks",
    name: "Money Stacks",
  },
  moneymouse: {
    redirectUrl: "/casino/pragmaticplay-money-mouse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MoneyMouse.webp",
    alt: "Money Mouse",
    name: "Money Mouse",
  },
  moneymoneymoney: {
    redirectUrl: "/casino/pragmaticplay-money-money-money",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MoneyMoneyMoney.webp",
    alt: "Money Money Money",
    name: "Money Money Money",
  },
  moleionaire: {
    redirectUrl: "/casino/pragmaticplay-moleionaire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Moleionaire.webp",
    alt: "Moleionaire",
    name: "Moleionaire",
  },
  mochimon: {
    redirectUrl: "/casino/pragmaticplay-mochimon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Mochimon.webp",
    alt: "Mochimon",
    name: "Mochimon",
  },
  miningrush: {
    redirectUrl: "/casino/pragmaticplay-mining-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MiningRush.webp",
    alt: "Mining Rush",
    name: "Mining Rush",
  },
  mightymunchingmelons: {
    redirectUrl: "/casino/pragmaticplay-mighty-munching-melons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MightyMunchingMelons.webp",
    alt: "Mighty Munching Melons",
    name: "Mighty Munching Melons",
  },
  mightykong: {
    redirectUrl: "/casino/pragmaticplay-mighty-kong",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MightyKong.webp",
    alt: "Mighty Kong",
    name: "Mighty Kong",
  },
  mightyhercules: {
    redirectUrl: "/casino/pragmaticplay-mighty-hercules",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MightyHercules.webp",
    alt: "Mighty Hercules",
    name: "Mighty Hercules",
  },
  mightofra: {
    redirectUrl: "/casino/pragmaticplay-might-of-ra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MightofRa.webp",
    alt: "Might of Ra",
    name: "Might of Ra",
  },
  medusasstone: {
    redirectUrl: "/casino/pragmaticplay-medusas-stone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MedusasStone.webp",
    alt: "Medusa's Stone",
    name: "Medusa's Stone",
  },
  masterjoker: {
    redirectUrl: "/casino/pragmaticplay-master-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MasterJoker.webp",
    alt: "Master Joker",
    name: "Master Joker",
  },
  mastergems: {
    redirectUrl: "/casino/pragmaticplay-master-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MasterGems.webp",
    alt: "Master Gems",
    name: "Master Gems",
  },
  masterchensfortune: {
    redirectUrl: "/casino/pragmaticplay-master-chens-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MasterChensFortune.webp",
    alt: "Master Chens Fortune",
    name: "Master Chens Fortune",
  },
  mammothgoldmegaways: {
    redirectUrl: "/casino/pragmaticplay-mammoth-gold-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MammothGoldMegaways.webp",
    alt: "Mammoth Gold Megaways",
    name: "Mammoth Gold Megaways",
  },
  majesticexpressgoldrun: {
    redirectUrl: "/casino/pragmaticplay-majestic-express-gold-run",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MajesticExpressGoldRun.webp",
    alt: "Majestic Express Gold Run",
    name: "Majestic Express Gold Run",
  },
  mahjongx: {
    redirectUrl: "/casino/pragmaticplay-mahjong-x",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongX.webp",
    alt: "Mahjong X",
    name: "Mahjong X",
  },
  mahjongwinssuperscatter: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWinsSuperScatter.webp",
    alt: "Mahjong Wins Super Scatter",
    name: "Mahjong Wins Super Scatter",
  },
  mahjongwinsbonus: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins-bonus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWinsBonus.webp",
    alt: "Mahjong Wins Bonus",
    name: "Mahjong Wins Bonus",
  },
  mahjongwins3blackscatter: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins-3-black-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWins3BlackScatter.webp",
    alt: "Mahjong Wins 3 - Black Scatter",
    name: "Mahjong Wins 3 - Black Scatter",
  },
  mahjongwins2: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWins2.webp",
    alt: "Mahjong Wins 2",
    name: "Mahjong Wins 2",
  },
  mahjongwinsgongxifacai: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins-gong-xi-fa-cai",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWinsGongXiFaCai.webp",
    alt: "Mahjong Wins - Gong Xi Fa Cai",
    name: "Mahjong Wins - Gong Xi Fa Cai",
  },
  mahjongwins: {
    redirectUrl: "/casino/pragmaticplay-mahjong-wins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongWins.webp",
    alt: "Mahjong Wins",
    name: "Mahjong Wins",
  },
  mahjongpanda: {
    redirectUrl: "/casino/pragmaticplay-mahjong-panda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongPanda.webp",
    alt: "Mahjong Panda",
    name: "Mahjong Panda",
  },
  mahjongbonanza: {
    redirectUrl: "/casino/pragmaticplay-mahjong-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MahjongBonanza.webp",
    alt: "Mahjong Bonanza",
    name: "Mahjong Bonanza",
  },
  magicianssecrets: {
    redirectUrl: "/casino/pragmaticplay-magicians-secrets",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MagiciansSecrets.webp",
    alt: "Magicians Secrets",
    name: "Magicians Secrets",
  },
  magicmoneymaze: {
    redirectUrl: "/casino/pragmaticplay-magic-money-maze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MagicMoneyMaze.webp",
    alt: "Magic Money Maze",
    name: "Magic Money Maze",
  },
  magicjourney: {
    redirectUrl: "/casino/pragmaticplay-magic-journey",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MagicJourne.webp",
    alt: "Magic Journey",
    name: "Magic Journey",
  },
  magiccrystals: {
    redirectUrl: "/casino/pragmaticplay-magic-crystals",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MagicCrysta.webp",
    alt: "Magic Crystals",
    name: "Magic Crystals",
  },
  madamemystiquemegaways: {
    redirectUrl: "/casino/pragmaticplay-madame-mystique-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MadameMystiqueMegaways.webp",
    alt: "Madame Mystique Megaways",
    name: "Madame Mystique Megaways",
  },
  madamedestinymegaways: {
    redirectUrl: "/casino/pragmaticplay-madame-destiny-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MadameDestinyMegaways.webp",
    alt: "Madame Destiny Megaways",
    name: "Madame Destiny Megaways",
  },
  madamedestiny: {
    redirectUrl: "/casino/pragmaticplay-madame-destiny",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/MadameDestiny.webp",
    alt: "Madame Destiny",
    name: "Madame Destiny",
  },
  hockeyleague: {
    redirectUrl: "/casino/pragmaticplay-hockey-league",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HockeyLeague.webp",
    alt: "Hockey League",
    name: "Hockey League",
  },
  hockeybonanza: {
    redirectUrl: "/casino/pragmaticplay-hockey-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HockeyBonanza.webp",
    alt: "Hockey Bonanza",
    name: "Hockey Bonanza",
  },
  hockeyattack: {
    redirectUrl: "/casino/pragmaticplay-hockey-attack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HockeyAttack.webp",
    alt: "Hockey Attack",
    name: "Hockey Attack",
  },
  himalayanwild: {
    redirectUrl: "/casino/pragmaticplay-himalayan-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HimalayanWild.webp",
    alt: "Himalayan Wild",
    name: "Himalayan Wild",
  },
  heroicspins: {
    redirectUrl: "/casino/pragmaticplay-heroic-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HeroicSpins.webp",
    alt: "Heroic Spins",
    name: "Heroic Spins",
  },

  herculessonofzeus: {
    redirectUrl: "/casino/pragmaticplay-hercules-son-of-zeus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HerculesSonofZeus.webp",
    alt: "Hercules Son of Zeus",
    name: "Hercules Son of Zeus",
  },
  herculesandpegasus: {
    redirectUrl: "/casino/pragmaticplay-hercules-and-pegasus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HerculesandPegasus.webp",
    alt: "Hercules and Pegasus",
    name: "Hercules and Pegasus",
  },
  hellviswild: {
    redirectUrl: "/casino/pragmaticplay-hellvis-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HellvisWild.webp",
    alt: "Hellvis Wild",
    name: "Hellvis Wild",
  },
  heistforthegoldennuggets: {
    redirectUrl: "/casino/pragmaticplay-heist-for-the-golden-nuggets",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HeistfortheGoldenNuggets.webp",
    alt: "Heist for the Golden Nuggets",
    name: "Heist for the Golden Nuggets",
  },
  heartofrio: {
    redirectUrl: "/casino/pragmaticplay-heart-of-rio",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HeartofRio.webp",
    alt: "Heart of Rio",
    name: "Heart of Rio",
  },
  heartofcleopatra: {
    redirectUrl: "/casino/pragmaticplay-heart-of-cleopatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HeartofCleopatra.webp",
    alt: "Heart of Cleopatra",
    name: "Heart of Cleopatra",
  },
  havefesten: {
    redirectUrl: "/casino/pragmaticplay-havefesten",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Havefesten.webp",
    alt: "Havefesten",
    name: "Havefesten",
  },
  happyhooves: {
    redirectUrl: "/casino/pragmaticplay-happy-hooves",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HappyHooves.webp",
    alt: "Happy Hooves",
    name: "Happy Hooves",
  },
  happyfortune: {
    redirectUrl: "/casino/pragmaticplay-happy-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HappyFortune.webp",
    alt: "Happy Fortune",
    name: "Happy Fortune",
  },
  handofmidas2: {
    redirectUrl: "/casino/pragmaticplay-hand-of-midas-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/HandofMidas2.webp",
    alt: "Hand of Midas 2",
    name: "Hand of Midas 2",
  },
  guaranaeyesoftheamazon: {
    redirectUrl: "/casino/pragmaticplay-guarana-eyes-of-the-amazon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GuaranaEyesoftheAmazon.webp",
    alt: "Guarana Eyes of the Amazon",
    name: "Guarana Eyes of the Amazon",
  },
  gretzkypowerpucks: {
    redirectUrl: "/casino/pragmaticplay-gretzky-power-pucks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GretzkyPowerPucks.webp",
    alt: "Gretzky Power Pucks",
    name: "Gretzky Power Pucks",
  },
  greekgods: {
    redirectUrl: "/casino/pragmaticplay-greek-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreekGods.webp",
    alt: "Greek Gods",
    name: "Greek Gods",
  },
  greedywolf: {
    redirectUrl: "/casino/pragmaticplay-greedy-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreedyWolf.webp",
    alt: "Greedy Wolf",
    name: "Greedy Wolf",
  },
  greedyfortunepig: {
    redirectUrl: "/casino/pragmaticplay-greedy-fortune-pig",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreedyFortunePig.webp",
    alt: "Greedy Fortune Pig",
    name: "Greedy Fortune Pig",
  },
  greatrhinomegaways: {
    redirectUrl: "/casino/pragmaticplay-great-rhino-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreatRhinoMegaways.webp",
    alt: "Great Rhino Megaways",
    name: "Great Rhino Megaways",
  },
  greatrhinodeluxe: {
    redirectUrl: "/casino/pragmaticplay-great-rhino-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreatRhinoDeluxe.webp",
    alt: "Great Rhino Deluxe",
    name: "Great Rhino Deluxe",
  },
  greatrhino: {
    redirectUrl: "/casino/pragmaticplay-great-rhino",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreatRhino.webp",
    alt: "Great Rhino",
    name: "Great Rhino",
  },
  greatreef: {
    redirectUrl: "/casino/pragmaticplay-great-reef",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GreatReef.webp",
    alt: "Great Reef",
    name: "Great Reef",
  },
  gravitybonanza: {
    redirectUrl: "/casino/pragmaticplay-gravity-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GravityBonanza.webp",
    alt: "Gravity Bonanza",
    name: "Gravity Bonanza",
  },
  graceofebisu: {
    redirectUrl: "/casino/pragmaticplay-grace-of-ebisu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GraceofEbisu.webp",
    alt: "Grace of Ebisu",
    name: "Grace of Ebisu",
  },
  gorillamayhem: {
    redirectUrl: "/casino/pragmaticplay-gorilla-mayhem",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GorillaMayhem.webp",
    alt: "Gorilla Mayhem",
    name: "Gorilla Mayhem",
  },
  goodluckgoodfortune: {
    redirectUrl: "/casino/pragmaticplay-good-luck-and-good-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoodLuck&GoodFortune.webp",
    alt: "Good Luck & Good Fortune",
    name: "Good Luck & Good Fortune",
  },
  goldenpig: {
    redirectUrl: "/casino/pragmaticplay-golden-pig",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldenPig.webp",
    alt: "Golden Pig",
    name: "Golden Pig",
  },
  goldenox: {
    redirectUrl: "/casino/pragmaticplay-golden-ox",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldenOx.webp",
    alt: "Golden Ox",
    name: "Golden Ox",
  },
  goldtraingpk: {
    redirectUrl: "/casino/pragmaticplay-gold-train-gpk",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldTrainGPK.webp",
    alt: "Gold Train GPK",
    name: "Gold Train GPK",
  },
  goldtrain: {
    redirectUrl: "/casino/pragmaticplay-gold-train",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldTrain.webp",
    alt: "Gold Train",
    name: "Gold Train",
  },
  goldrush: {
    redirectUrl: "/casino/pragmaticplay-gold-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldRush.webp",
    alt: "Gold Rush",
    name: "Gold Rush",
  },
  goldparty2afterhours: {
    redirectUrl: "/casino/pragmaticplay-gold-party-2-after-hours",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldParty2AfterHours.webp",
    alt: "Gold Party 2 - After Hours",
    name: "Gold Party 2 - After Hours",
  },
  goldparty: {
    redirectUrl: "/casino/pragmaticplay-gold-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldParty.webp",
    alt: "Gold Party",
    name: "Gold Party",
  },
  goldoasis: {
    redirectUrl: "/casino/pragmaticplay-gold-oasis",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldOasis.webp",
    alt: "Gold Oasis",
    name: "Gold Oasis",
  },
  goldcarpbonanza: {
    redirectUrl: "/casino/pragmaticplay-gold-carp-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoldCarpBonanza.webp",
    alt: "Gold Carp Bonanza",
    name: "Gold Carp Bonanza",
  },
  godsofgiza: {
    redirectUrl: "/casino/pragmaticplay-gods-of-giza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GodsofGiza.webp",
    alt: "Gods of Giza",
    name: "Gods of Giza",
  },
  goblinheistpowernudge: {
    redirectUrl: "/casino/pragmaticplay-goblin-heist-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GoblinHeistPowerNudg.webp",
    alt: "Goblin Heist PowerNudge",
    name: "Goblin Heist PowerNudge",
  },
  gloriousrome: {
    redirectUrl: "/casino/pragmaticplay-glorious-rome",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GloriousRome.webp",
    alt: "Glorious Rome",
    name: "Glorious Rome",
  },
  gemstone: {
    redirectUrl: "/casino/pragmaticplay-gemstone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Gemstone.webp",
    alt: "Gemstone",
    name: "Gemstone",
  },
  gemsofserengeti: {
    redirectUrl: "/casino/pragmaticplay-gems-of-serengeti",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GemsofSerengeti.webp",
    alt: "Gems of Serengeti",
    name: "Gems of Serengeti",
  },
  gemsbonanza: {
    redirectUrl: "/casino/pragmaticplay-gems-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GemsBonanza.webp",
    alt: "Gems Bonanza",
    name: "Gems Bonanza",
  },
  gemine: {
    redirectUrl: "/casino/pragmaticplay-gemine",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Gemine.webp",
    alt: "Gemine",
    name: "Gemine",
  },
  gemtrio: {
    redirectUrl: "/casino/pragmaticplay-gem-trio",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GemTrio.webp",
    alt: "Gem Trio",
    name: "Gem Trio",
  },
  gemfirefortune: {
    redirectUrl: "/casino/pragmaticplay-gem-fire-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GemFireFortune.webp",
    alt: "Gem Fire Fortune",
    name: "Gem Fire Fortune",
  },
  gemelevator: {
    redirectUrl: "/casino/pragmaticplay-gem-elevator",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GemElevator.webp",
    alt: "Gem Elevator",
    name: "Gem Elevator",
  },
  gearsofhorus: {
    redirectUrl: "/casino/pragmaticplay-gears-of-horus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GearsofHorus.webp",
    alt: "Gears of Horus",
    name: "Gears of Horus",
  },
  gatotkacasfury: {
    redirectUrl: "/casino/pragmaticplay-gatot-kacas-fury",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatotKacasFury.webp",
    alt: "Gatot Kacas Fury",
    name: "Gatot Kacas Fury",
  },
  gatestoeldorado: {
    redirectUrl: "/casino/pragmaticplay-gates-to-el-dorado",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/gatestoeldorado.webp",
    alt: "Gates to El Dorado",
    name: "Gates to El Dorado",
  },
  gatesofxibalba: {
    redirectUrl: "/casino/pragmaticplay-gates-of-xibalba",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofXibalba.webp",
    alt: "Gates of Xibalba",
    name: "Gates of Xibalba",
  },
  gatesofvalhalla: {
    redirectUrl: "/casino/pragmaticplay-gates-of-valhalla",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofValhalla.webp",
    alt: "Gates of Valhalla",
    name: "Gates of Valhalla",
  },
  gatesofolympusxmas1000: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus-xmas-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympusXmas1000.webp",
    alt: "Gates of Olympus Xmas 1000",
    name: "Gates of Olympus Xmas 1000",
  },
  gatesofolympussuper: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympusSUPERSCATTER.webp",
    alt: "Gates of Olympus SUPER SCATTER",
    name: "Gates of Olympus SUPER SCATTER",
  },
  gatesofolympusdice: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympusDice.webp",
    alt: "Gates of Olympus Dice",
    name: "Gates of Olympus Dice",
  },
  gatesofolympus1000dice: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus-1000-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympus1000Dice.webp",
    alt: "Gates of Olympus 1000 Dice",
    name: "Gates of Olympus 1000 Dice",
  },
  gatesofolympus1000: {
    redirectUrl: "/casino/pragmaticplay-gates-of-olympus-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofOlympus1000.webp",
    alt: "Gates of Olympus 1000",
    name: "Gates of Olympus 1000",
  },

  gatesofmars: {
    redirectUrl: "/casino/pragmaticplay-gates-of-mars",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/gatesofmars.webp",
    alt: "Gates of Mars",
    name: "Gates of Mars",
  },
  gatesofleovegas1000: {
    redirectUrl: "/casino/pragmaticplay-gates-of-leovegas-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofLeoVegas1000.webp",
    alt: "Gates of LeoVegas 1000",
    name: "Gates of LeoVegas 1000",
  },
  gatesofhunny: {
    redirectUrl: "/casino/pragmaticplay-gates-of-hunny",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/gatesofhunny.webp",
    alt: "Gates of LeoVegas 1000",
    name: "Gates of LeoVegas 1000",
  },
  gatesofheaven: {
    redirectUrl: "/casino/pragmaticplay-gates-of-heaven",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofHeaven.webp",
    alt: "Gates of Heaven",
    name: "Gates of Heaven",
  },

  gatesofgatotkaca: {
    redirectUrl: "/casino/pragmaticplay-gates-of-gatotkaca",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofGatotkaca.webp",
    alt: "Gates of Gatotkaca",
    name: "Gates of Gatotkaca",
  },
  gatesofgatotkaca1000: {
    redirectUrl: "/casino/pragmaticplay-gates-of-gatot-kaca-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofGatotKaca1000.webp",
    alt: "Gates of Gatot Kaca 1000",
    name: "Gates of Gatot Kaca 1000",
  },
  gatesofdragonjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-gates-of-dragon-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofDragonJackpotPlay.webp",
    alt: "Gates of Dragon Jackpot Play",
    name: "Gates of Dragon Jackpot Play",
  },
  gatesofcresus: {
    redirectUrl: "/casino/pragmaticplay-gates-of-cresus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofCresus.webp",
    alt: "Gates of Cresus",
    name: "Gates of Cresus",
  },
  gatesofaztec: {
    redirectUrl: "/casino/pragmaticplay-gates-of-aztec",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GatesofAztec.webp",
    alt: "Gates of Aztec",
    name: "Gates of Aztec",
  },
  gameshowpartyjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-gameshow-party-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GameshowPartyJackpotPlay.webp",
    alt: "Gameshow Party Jackpot Play",
    name: "Gameshow Party Jackpot Play",
  },
  gamesinolympus: {
    redirectUrl: "/casino/pragmaticplay-games-in-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/GamesinOlympus.webp",
    alt: "Games in Olympus",
    name: "Games in Olympus",
  },
  furyofodinmegaways: {
    redirectUrl: "/casino/pragmaticplay-fury-of-odin-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FuryofOdinMegaways.webp",
    alt: "Fury of Odin Megaways",
    name: "Fury of Odin Megaways",
  },
  fun88dragons: {
    redirectUrl: "/casino/pragmaticplay-fun88-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Fun88Dragons.webp",
    alt: "Fun88 Dragons",
    name: "Fun88 Dragons",
  },
  fufufu: {
    redirectUrl: "/casino/pragmaticplay-fu-fu-fu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FuFuFu.webp",
    alt: "Fu Fu Fu",
    name: "Fu Fu Fu",
  },
  fruitytreats: {
    redirectUrl: "/casino/pragmaticplay-fruity-treats",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruityTreats.webp",
    alt: "Fruity Treats",
    name: "Fruity Treats",
  },
  fruityblast: {
    redirectUrl: "/casino/pragmaticplay-fruity-blast",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruityBlast.webp",
    alt: "Fruity Blast",
    name: "Fruity Blast",
  },
  fruitsoftheamazon: {
    redirectUrl: "/casino/pragmaticplay-fruits-of-the-amazon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruitsoftheAmazon.webp",
    alt: "Fruits of the Amazon",
    name: "Fruits of the Amazon",
  },
  fruitrainbow: {
    redirectUrl: "/casino/pragmaticplay-fruit-rainbow",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruitRainbow.webp",
    alt: "Fruit Rainbow",
    name: "Fruit Rainbow",
  },
  fruitparty2: {
    redirectUrl: "/casino/pragmaticplay-fruit-party-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruitParty2.webp",
    alt: "Fruit Party 2",
    name: "Fruit Party 2",
  },
  fruitparty: {
    redirectUrl: "/casino/pragmaticplay-fruit-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FruitParty.webp",
    alt: "Fruit Party",
    name: "Fruit Party",
  },
  frozentropics: {
    redirectUrl: "/casino/pragmaticplay-frozen-tropics",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FrozenTropics.webp",
    alt: "Frozen Tropics",
    name: "Frozen Tropics",
  },
  frontrunneroddson: {
    redirectUrl: "/casino/pragmaticplay-front-runner-odds-on",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FrontRunnerOddsOn.webp",
    alt: "Front Runner Odds On",
    name: "Front Runner Odds On",
  },
  frogsandfruits: {
    redirectUrl: "/casino/pragmaticplay-frogs-and-fruits",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FrogsandFruits.webp",
    alt: "Frogs and Fruits",
    name: "Frogs and Fruits",
  },
  frogsbugs: {
    redirectUrl: "/casino/pragmaticplay-frogs-and-bugs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Frogs&Bugs.webp",
    alt: "Frogs & Bugs",
    name: "Frogs & Bugs",
  },
  fortunesofaztec: {
    redirectUrl: "/casino/pragmaticplay-fortunes-of-aztec",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FortunesofAztec.webp",
    alt: "Fortunes of Aztec",
    name: "Fortunes of Aztec",
  },
  fortuneofgiza: {
    redirectUrl: "/casino/pragmaticplay-fortune-of-giza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FortuneofGiza.webp",
    alt: "Fortune of Giza",
    name: "Fortune of Giza",
  },
  fortunehitnroll: {
    redirectUrl: "/casino/pragmaticplay-fortune-hitn-roll",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FortuneHitnRoll.webp",
    alt: "Fortune Hit'n Roll",
    name: "Fortune Hit'n Roll",
  },
  fortuneace: {
    redirectUrl: "/casino/pragmaticplay-fortune-ace",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FortuneAce.webp",
    alt: "Fortune Ace",
    name: "Fortune Ace",
  },
  forgingwilds: {
    redirectUrl: "/casino/pragmaticplay-forging-wilds",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ForgingWilds.webp",
    alt: "Forging Wilds",
    name: "Forging Wilds",
  },
  forgeofolympus: {
    redirectUrl: "/casino/pragmaticplay-forge-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ForgeofOlympus.webp",
    alt: "Forge of Olympus",
    name: "Forge of Olympus",
  },
  fonzosfelinefortunes: {
    redirectUrl: "/casino/pragmaticplay-fonzos-feline-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FonzosFelineFortunes.webp",
    alt: "Fonzos Feline Fortunes",
    name: "Fonzos Feline Fortunes",
  },
  flyinghippo: {
    redirectUrl: "/casino/pragmaticplay-flying-hippo",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FlyingHippo.webp",
    alt: "Flying Hippo",
    name: "Flying Hippo",
  },
  floatingdragonyearofthesnake: {
    redirectUrl: "/casino/pragmaticplay-floating-dragon-year-of-the-snake",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FloatingDragonYearoftheSnake.webp",
    alt: "Floating Dragon Year of the Snake",
    name: "Floating Dragon Year of the Snake",
  },
  floatingdragonnewyearfestivalultramegawaysholdspin: {
    redirectUrl:
      "/casino/pragmaticplay-floating-dragon-new-year-festival-ultra-megaways-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl:
      "./images/pragmaticplay/FloatingDragonNewYearFestivalUltraMegawaysHold&Spin.webp",
    alt: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
    name: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
  },
  floatingdragonholdspinmegaways: {
    redirectUrl: "/casino/pragmaticplay-floating-dragon-hold-and-spin-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FloatingDragonHold&SpinMegaways.webp",
    alt: "Floating Dragon Hold & Spin Megaways",
    name: "Floating Dragon Hold & Spin Megaways",
  },
  floatingdragondragonboatfestival: {
    redirectUrl: "/casino/pragmaticplay-floating-dragon-dragon-boat-festival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FloatingDragon-DragonBoatFestiva.webp",
    alt: "Floating Dragon  Dragon Boat Festival",
    name: "Floating Dragon  Dragon Boat Festival",
  },
  floatingdragon: {
    redirectUrl: "/casino/pragmaticplay-floating-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FloatingDragon.webp",
    alt: "Floating Dragon",
    name: "Floating Dragon",
  },
  fishinreels: {
    redirectUrl: "/casino/pragmaticplay-fishin-reels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FishinReels.webp",
    alt: "Fishin Reels",
    name: "Fishin Reels",
  },
  fisheye: {
    redirectUrl: "/casino/pragmaticplay-fish-eye",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FishEye.webp",
    alt: "Fish Eye",
    name: "Fish Eye",
  },
  firestrike2: {
    redirectUrl: "/casino/pragmaticplay-fire-strike-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireStrike2.webp",
    alt: "Fire Strike 2",
    name: "Fire Strike 2",
  },
  firestrike: {
    redirectUrl: "/casino/pragmaticplay-fire-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireStrike.webp",
    alt: "Fire Strike",
    name: "Fire Strike",
  },
  firestampede: {
    redirectUrl: "/casino/pragmaticplay-fire-stampede",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireStamped.webp",
    alt: "Fire Stampede",
    name: "Fire Stampede",
  },
  fireportals: {
    redirectUrl: "/casino/pragmaticplay-fire-portals",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FirePortals.webp",
    alt: "Fire Portals",
    name: "Fire Portals",
  },
  firehot5jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot5JackpotPlay.webp",
    alt: "Fire Hot 5 Jackpot Play",
    name: "Fire Hot 5 Jackpot Play",
  },
  firehot5: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot5.webp",
    alt: "Fire Hot 5",
    name: "Fire Hot 5",
  },
  firehot40jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-40-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot40JackpotPlay.webp",
    alt: "Fire Hot 40 Jackpot Play",
    name: "Fire Hot 40 Jackpot Play",
  },
  firehot40: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-40",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot40.webp",
    alt: "Fire Hot 40",
    name: "Fire Hot 40",
  },
  firehot20jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-20-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot20JackpotPlay.webp",
    alt: "Fire Hot 20 Jackpot Play",
    name: "Fire Hot 20 Jackpot Play",
  },
  firehot20: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-20",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot20.webp",
    alt: "Fire Hot 20",
    name: "Fire Hot 20",
  },
  firehot100jackpotplay: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-100-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot100JackpotPla.webp",
    alt: "Fire Hot 100 Jackpot Play",
    name: "Fire Hot 100 Jackpot Play",
  },
  firehot100: {
    redirectUrl: "/casino/pragmaticplay-fire-hot-100",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireHot100.webp",
    alt: "Fire Hot 100",
    name: "Fire Hot 100",
  },
  firearcher: {
    redirectUrl: "/casino/pragmaticplay-fire-archer",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FireArcher.webp",
    alt: "Fire Archer",
    name: "Fire Archer",
  },
  fire88: {
    redirectUrl: "/casino/pragmaticplay-fire-88",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Fire88.webp",
    alt: "Fire 88",
    name: "Fire 88",
  },
  fingerlicknfreespins: {
    redirectUrl: "/casino/pragmaticplay-finger-lickn-free-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FingerLicknFreeSpins.webp",
    alt: "Finger Lick'n Free Spins",
    name: "Finger Lick'n Free Spins",
  },
  fiestafortune: {
    redirectUrl: "/casino/pragmaticplay-fiesta-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FiestaFortune.webp",
    alt: "Fiesta Fortune",
    name: "Fiesta Fortune",
  },
  fiestadesanfermin: {
    redirectUrl: "/casino/pragmaticplay-fiesta-de-san-fermin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FiestadeSanFermin.webp",
    alt: "Fiesta de San Fermin",
    name: "Fiesta de San Fermin",
  },
  fatpanda: {
    redirectUrl: "/casino/pragmaticplay-fat-panda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FatPanda.webp",
    alt: "Fat Panda",
    name: "Fat Panda",
  },
  fangtasticfreespins: {
    redirectUrl: "/casino/pragmaticplay-fangtastic-freespins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FangtasticFreespins.webp",
    alt: "Fangtastic Freespins",
    name: "Fangtastic Freespins",
  },
  fairytalefortune: {
    redirectUrl: "/casino/pragmaticplay-fairytale-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/FairytaleFortune.webp",
    alt: "Fairytale Fortune",
    name: "Fairytale Fortune",
  },
  eyeofthestorm: {
    redirectUrl: "/casino/pragmaticplay-eye-of-the-storm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EyeoftheStorm.webp",
    alt: "Eye of the Storm",
    name: "Eye of the Storm",
  },
  eyeofspartacus: {
    redirectUrl: "/casino/pragmaticplay-eye-of-spartacus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EyeofSpartacus.webp",
    alt: "Eye of Spartacus",
    name: "Eye of Spartacus",
  },
  eyeofcleopatra: {
    redirectUrl: "/casino/pragmaticplay-eye-of-cleopatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EyeofCleopatra.webp",
    alt: "Eye of Cleopatra",
    name: "Eye of Cleopatra",
  },
  extrajuicymegaways: {
    redirectUrl: "/casino/pragmaticplay-extra-juicy-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ExtraJuicyMegaways.webp",
    alt: "Extra Juicy Megaways",
    name: "Extra Juicy Megaways",
  },
  extrajuicy: {
    redirectUrl: "/casino/pragmaticplay-extra-juicy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ExtraJuicy.webp",
    alt: "Extra Juicy",
    name: "Extra Juicy",
  },
  excaliburunleashed: {
    redirectUrl: "/casino/pragmaticplay-excalibur-unleashed",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ExcaliburUnleashed.webp",
    alt: "Excalibur Unleashed",
    name: "Excalibur Unleashed",
  },
  eternalempressfreezetime: {
    redirectUrl: "/casino/pragmaticplay-eternal-empress-freeze-time",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EternalEmpressFreezeTime.webp",
    alt: "Eternal Empress - Freeze Time",
    name: "Eternal Empress - Freeze Time",
  },
  escapethepyramidfireice: {
    redirectUrl: "/casino/pragmaticplay-escape-the-pyramid-fire-and-ice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EscapethePyramidFire&Ice.webp",
    alt: "Escape the Pyramid Fire & Ice",
    name: "Escape the Pyramid Fire & Ice",
  },
  emptythebank: {
    redirectUrl: "/casino/pragmaticplay-empty-the-bank",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EmptytheBank.webp",
    alt: "Empty the Bank",
    name: "Empty the Bank",
  },
  emperorcaishen: {
    redirectUrl: "/casino/pragmaticplay-emperor-caishen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EmperorCaishen.webp",
    alt: "Emperor Caishen",
    name: "Emperor Caishen",
  },
  emeraldkingrainbowroad: {
    redirectUrl: "/casino/pragmaticplay-emerald-king-rainbow-road",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EmeraldKingRainbowRoad.webp",
    alt: "Emerald King Rainbow Road",
    name: "Emerald King Rainbow Road",
  },
  emeraldking: {
    redirectUrl: "/casino/pragmaticplay-emerald-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EmeraldKing.webp",
    alt: "Emerald King",
    name: "Emerald King",
  },
  elementalgemsmegaways: {
    redirectUrl: "/casino/pragmaticplay-elemental-gems-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ElementalGemsMegaways.webp",
    alt: "Elemental Gems Megaways",
    name: "Elemental Gems Megaways",
  },
  eldoradothecityofgold: {
    redirectUrl: "/casino/pragmaticplay-el-dorado-the-city-of-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ElDoradoTheCityofGold.webp",
    alt: "El Dorado The City of Gold",
    name: "El Dorado The City of Gold",
  },
  egyptianfortunes: {
    redirectUrl: "/casino/pragmaticplay-egyptian-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EgyptianFortunes.webp",
    alt: "Egyptian Fortunes",
    name: "Egyptian Fortunes",
  },
  egyptbonanza: {
    redirectUrl: "/casino/pragmaticplay-egypt-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EgyptBonanza.webp",
    alt: "Egypt Bonanza",
    name: "Egypt Bonanza",
  },
  eggrushjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-egg-rush-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/EggRushJackpotPlay.webp",
    alt: "Egg Rush Jackpot Play",
    name: "Egg Rush Jackpot Play",
  },
  dynamitediggindoug: {
    redirectUrl: "/casino/pragmaticplay-dynamite-diggin-doug",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DynamiteDigginDoug.webp",
    alt: "Dynamite Diggin Doug",
    name: "Dynamite Diggin Doug",
  },
  dwarvengolddeluxe: {
    redirectUrl: "/casino/pragmaticplay-dwarven-gold-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DwarvenGoldDeluxe.webp",
    alt: "Dwarven Gold Deluxe",
    name: "Dwarven Gold Deluxe",
  },
  dwarfdragon: {
    redirectUrl: "/casino/pragmaticplay-dwarf-and-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Dwarf&Dragon.webp",
    alt: "Dwarf & Dragon",
    name: "Dwarf & Dragon",
  },
  drillthatgold: {
    redirectUrl: "/casino/pragmaticplay-drill-that-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DrillthatGold.webp",
    alt: "Drill that Gold",
    name: "Drill that Gold",
  },
  dragonkingdomeyesoffire: {
    redirectUrl: "/casino/pragmaticplay-dragon-kingdom-eyes-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonKingdomEyesofFire.webp",
    alt: "Dragon Kingdom Eyes of Fire",
    name: "Dragon Kingdom Eyes of Fire",
  },
  dragonkingdom: {
    redirectUrl: "/casino/pragmaticplay-dragon-kingdom",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonKingdom.webp",
    alt: "Dragon Kingdom",
    name: "Dragon Kingdom",
  },
  dragonkinghotpots: {
    redirectUrl: "/casino/pragmaticplay-dragon-king-hot-pots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonKingHotPots.webp",
    alt: "Dragon King Hot Pots",
    name: "Dragon King Hot Pots",
  },
  dragonhotholdandspin: {
    redirectUrl: "/casino/pragmaticplay-dragon-hot-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonHotHoldandSpin.webp",
    alt: "Dragon Hot Hold and Spin",
    name: "Dragon Hot Hold and Spin",
  },
  dragonhero: {
    redirectUrl: "/casino/pragmaticplay-dragon-hero",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonHero.webp",
    alt: "Dragon Hero",
    name: "Dragon Hero",
  },
  dragongold88: {
    redirectUrl: "/casino/pragmaticplay-dragon-gold-88",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragonGold88.webp",
    alt: "Dragon Gold 88",
    name: "Dragon Gold 88",
  },
  dragojewelsoffortune: {
    redirectUrl: "/casino/pragmaticplay-drago-jewels-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DragoJewelsofFortune.webp",
    alt: "Drago  Jewels of Fortune",
    name: "Drago  Jewels of Fortune",
  },
  downtherails: {
    redirectUrl: "/casino/pragmaticplay-down-the-rails",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DowntheRails.webp",
    alt: "Down the Rails",
    name: "Down the Rails",
  },
  discolady: {
    redirectUrl: "/casino/pragmaticplay-disco-lady",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DiscoLady.webp",
    alt: "Disco Lady",
    name: "Disco Lady",
  },
  dinodrop: {
    redirectUrl: "/casino/pragmaticplay-dino-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DinoDrop.webp",
    alt: "Dino Drop",
    name: "Dino Drop",
  },
  dingdongchristmasbells: {
    redirectUrl: "/casino/pragmaticplay-ding-dong-christmas-bells",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DingDongChristmasBells.webp",
    alt: "Ding Dong Christmas Bells",
    name: "Ding Dong Christmas Bells",
  },
  diamondstrike: {
    redirectUrl: "/casino/pragmaticplay-diamond-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DiamondStrike.webp",
    alt: "Diamond Strike",
    name: "Diamond Strike",
  },
  diamondcascade: {
    redirectUrl: "/casino/pragmaticplay-diamond-cascade",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DiamondCascade.webp",
    alt: "Diamond Cascade",
    name: "Diamond Cascade",
  },
  devilicious: {
    redirectUrl: "/casino/pragmaticplay-devilicious",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Devilicious.webp",
    alt: "Devilicious",
    name: "Devilicious",
  },
  deviljoker: {
    redirectUrl: "/casino/pragmaticplay-devil-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DevilJoker.webp",
    alt: "Devil Joker",
    name: "Devil Joker",
  },
  demonpots: {
    redirectUrl: "/casino/pragmaticplay-demon-pots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DemonPots.webp",
    alt: "Demon Pots",
    name: "Demon Pots",
  },
  dayofdead: {
    redirectUrl: "/casino/pragmaticplay-day-of-dead",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DayofDead.webp",
    alt: "Day of Dead",
    name: "Day of Dead",
  },
  danielnegreanusfishbuffet: {
    redirectUrl: "/casino/pragmaticplay-daniel-negreanus-fish-buffet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DanielNegreanusFishBuffet.webp",
    alt: "Daniel Negreanu's Fish Buffet",
    name: "Daniel Negreanu's Fish Buffet",
  },
  danceparty: {
    redirectUrl: "/casino/pragmaticplay-dance-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DanceParty.webp",
    alt: "Dance Party",
    name: "Dance Party",
  },
  davincistreasure: {
    redirectUrl: "/casino/pragmaticplay-da-vincis-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/DaVincisTreasure.webp",
    alt: "Da Vincis Treasure",
    name: "Da Vincis Treasure",
  },
  cyclopssmash: {
    redirectUrl: "/casino/pragmaticplay-cyclops-smash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CyclopsSmash.webp",
    alt: "Cyclops Smash",
    name: "Cyclops Smash",
  },
  cyberheist: {
    redirectUrl: "/casino/pragmaticplay-cyber-heist",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CyberHeist.webp",
    alt: "Cyber Heist",
    name: "Cyber Heist",
  },
  curseofthewerewolfmegaways: {
    redirectUrl: "/casino/pragmaticplay-curse-of-the-werewolf-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CurseoftheWerewolfMegaways.webp",
    alt: "Curse of the Werewolf Megaways",
    name: "Curse of the Werewolf Megaways",
  },
  crystalcavernsmegaways: {
    redirectUrl: "/casino/pragmaticplay-crystal-caverns-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CrystalCavernsMegaways.webp",
    alt: "Crystal Caverns Megaways",
    name: "Crystal Caverns Megaways",
  },
  crownoffirejackpotplay: {
    redirectUrl: "/casino/pragmaticplay-crown-of-fire-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/crownoffirejackpotplays.webp",
    alt: "Crown of Fire Jackpot Play",
    name: "Crown of Fire Jackpot Play",
  },
  crownoffire: {
    redirectUrl: "/casino/pragmaticplay-crown-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CrownofFire.webp",
    alt: "Crown of Fire",
    name: "Crown of Fire",
  },
  crazy7s: {
    redirectUrl: "/casino/pragmaticplay-crazy-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Crazy7s.webp",
    alt: "Crazy 7s",
    name: "Crazy 7s",
  },
  crankitup: {
    redirectUrl: "/casino/pragmaticplay-crank-it-up",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CrankItUp.webp",
    alt: "Crank It Up",
    name: "Crank It Up",
  },
  cowboysgold: {
    redirectUrl: "/casino/pragmaticplay-cowboys-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CowboysGold.webp",
    alt: "Cowboys Gold",
    name: "Cowboys Gold",
  },
  cowboycoins: {
    redirectUrl: "/casino/pragmaticplay-cowboy-coins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CowboyCoins.webp",
    alt: "Cowboy Coins",
    name: "Cowboy Coins",
  },
  countryfarming: {
    redirectUrl: "/casino/pragmaticplay-country-farming",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CountryFarming.webp",
    alt: "Country Farming",
    name: "Country Farming",
  },
  cosmolotbonanza: {
    redirectUrl: "/casino/pragmaticplay-cosmolot-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CosmolotBonanza.webp",
    alt: "Cosmolot Bonanza",
    name: "Cosmolot Bonanza",
  },
  cosmiccash: {
    redirectUrl: "/casino/pragmaticplay-cosmic-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CosmicCash.webp",
    alt: "Cosmic Cash",
    name: "Cosmic Cash",
  },
  coralriches: {
    redirectUrl: "/casino/pragmaticplay-coral-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CoralRiches.webp",
    alt: "Coral Riches",
    name: "Coral Riches",
  },
  congocashxl: {
    redirectUrl: "/casino/pragmaticplay-congo-cash-xl",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CongoCashXL.webp",
    alt: "Congo Cash XL",
    name: "Congo Cash XL",
  },
  congocash: {
    redirectUrl: "/casino/pragmaticplay-congo-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CongoCash.webp",
    alt: "Congo Cash",
    name: "Congo Cash",
  },
  colossalcashzone: {
    redirectUrl: "/casino/pragmaticplay-colossal-cash-zone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ColossalCashZone.webp",
    alt: "Colossal Cash Zone",
    name: "Colossal Cash Zone",
  },
  coffeewild: {
    redirectUrl: "/casino/pragmaticplay-coffee-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CoffeeWild.webp",
    alt: "Coffee Wild",
    name: "Coffee Wild",
  },
  clubtropicanahappyhour: {
    redirectUrl: "/casino/pragmaticplay-club-tropicana-happy-hour",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ClubTropicanaHappyHour.webp",
    alt: "Club Tropicana Happy Hour",
    name: "Club Tropicana Happy Hour",
  },
  clubtropicana: {
    redirectUrl: "/casino/pragmaticplay-club-tropicana",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ClubTropicana.webp",
    alt: "Club Tropicana",
    name: "Club Tropicana",
  },
  clovergold: {
    redirectUrl: "/casino/pragmaticplay-clover-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CloverGold.webp",
    alt: "Clover Gold",
    name: "Clover Gold",
  },
  cleocatra: {
    redirectUrl: "/casino/pragmaticplay-cleocatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Cleocatra.webp",
    alt: "Cleocatra",
    name: "Cleocatra",
  },
  christmascarolmegaways: {
    redirectUrl: "/casino/pragmaticplay-christmas-carol-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChristmasCarolMegaways.webp",
    alt: "Christmas Carol Megaways",
    name: "Christmas Carol Megaways",
  },
  christmasbigbassbonanza: {
    redirectUrl: "/casino/pragmaticplay-christmas-big-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChristmasBigBassBonanza.webp",
    alt: "Christmas Big Bass Bonanza",
    name: "Christmas Big Bass Bonanza",
  },
  chilliheatspicyspins: {
    redirectUrl: "/casino/pragmaticplay-chilli-heat-spicy-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChilliHeatSpicySpins.webp",
    alt: "Chilli Heat Spicy Spins",
    name: "Chilli Heat Spicy Spins",
  },
  chilliheatmegaways: {
    redirectUrl: "/casino/pragmaticplay-chilli-heat-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChilliHeatMegaways.webp",
    alt: "Chilli Heat Megaways",
    name: "Chilli Heat Megaways",
  },
  chilliheat: {
    redirectUrl: "/casino/pragmaticplay-chilli-heat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChilliHeat.webp",
    alt: "Chilli Heat",
    name: "Chilli Heat",
  },
  chickendrop: {
    redirectUrl: "/casino/pragmaticplay-chicken-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChickenDrop.webp",
    alt: "Chicken Drop",
    name: "Chicken Drop",
  },
  chickenchase: {
    redirectUrl: "/casino/pragmaticplay-chicken-chase",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChickenChase.webp",
    alt: "Chicken Chase",
    name: "Chicken Chase",
  },
  chestsofcaishen: {
    redirectUrl: "/casino/pragmaticplay-chests-of-cai-shen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/ChestsofCaiShen.webp",
    alt: "Chests of Cai Shen",
    name: "Chests of Cai Shen",
  },
  cheekyemperor: {
    redirectUrl: "/casino/pragmaticplay-cheeky-emperor",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CheekyEmperor.webp",
    alt: "Cheeky Emperor",
    name: "Cheeky Emperor",
  },
  castleoffire: {
    redirectUrl: "/casino/pragmaticplay-castle-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CastleofFire.webp",
    alt: "Castle of Fire",
    name: "Castle of Fire",
  },
  cashpatrol: {
    redirectUrl: "/casino/pragmaticplay-cash-patrol",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CashPatrol.webp",
    alt: "Cash Patrol",
    name: "Cash Patrol",
  },
  cashchips: {
    redirectUrl: "/casino/pragmaticplay-cash-chips",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CashChips.webp",
    alt: "Cash Chips",
    name: "Cash Chips",
  },
  cashbox: {
    redirectUrl: "/casino/pragmaticplay-cash-box",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CashBox.webp",
    alt: "Cash Box",
    name: "Cash Box",
  },
  cashbonanza: {
    redirectUrl: "/casino/pragmaticplay-cash-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CashBonanza.webp",
    alt: "Cash Bonanza",
    name: "Cash Bonanza",
  },
  cappadocia: {
    redirectUrl: "/casino/pragmaticplay-cappadocia",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Cappadocia.webp",
    alt: "Cappadocia",
    name: "Cappadocia",
  },
  candyvillage: {
    redirectUrl: "/casino/pragmaticplay-candy-village",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyVillage.webp",
    alt: "Candy Village",
    name: "Candy Village",
  },
  candystars: {
    redirectUrl: "/casino/pragmaticplay-candy-stars",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyStars.webp",
    alt: "Candy Stars",
    name: "Candy Stars",
  },
  candyjarclusters: {
    redirectUrl: "/casino/pragmaticplay-candy-jar-clusters",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyJarClusters.webp",
    alt: "Candy Jar Clusters",
    name: "Candy Jar Clusters",
  },
  candycorner: {
    redirectUrl: "/casino/pragmaticplay-candy-corner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyCorner.webp",
    alt: "Candy Corner",
    name: "Candy Corner",
  },
  candyblitzbombs: {
    redirectUrl: "/casino/pragmaticplay-candy-blitz-bombs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyBlitzBombs.webp",
    alt: "Candy Blitz Bombs",
    name: "Candy Blitz Bombs",
  },
  candyblitz: {
    redirectUrl: "/casino/pragmaticplay-candy-blitz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CandyBlitz.webp",
    alt: "Candy Blitz",
    name: "Candy Blitz",
  },
  caishensgold: {
    redirectUrl: "/casino/pragmaticplay-caishens-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CaishensGold.webp",
    alt: "Caishens Gold",
    name: "Caishens Gold",
  },
  caishensgemsjackpotplay: {
    redirectUrl: "/casino/pragmaticplay-caishens-gems-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CaishensGemsJackpotPlay.webp",
    alt: "Caishen's Gems Jackpot Play",
    name: "Caishen's Gems Jackpot Play",
  },
  caishenscash: {
    redirectUrl: "/casino/pragmaticplay-caishens-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/CaishensCash.webp",
    alt: "Caishens Cash",
    name: "Caishens Cash",
  },
  busybees: {
    redirectUrl: "/casino/pragmaticplay-busy-bees",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BusyBees.webp",
    alt: "Busy Bees",
    name: "Busy Bees",
  },
  bullfiesta: {
    redirectUrl: "/casino/pragmaticplay-bull-fiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BullFiesta.webp",
    alt: "Bull Fiesta",
    name: "Bull Fiesta",
  },
  buffalokinguntamedmegaways: {
    redirectUrl: "/casino/pragmaticplay-buffalo-king-untamed-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BuffaloKingUntamedMegaway.webp",
    alt: "Buffalo King Untamed Megaways",
    name: "Buffalo King Untamed Megaways",
  },
  buffalokingmegaways: {
    redirectUrl: "/casino/pragmaticplay-buffalo-king-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BuffaloKingMegaways.webp",
    alt: "Buffalo King Megaways",
    name: "Buffalo King Megaways",
  },
  buffaloking: {
    redirectUrl: "/casino/pragmaticplay-buffalo-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BuffaloKing.webp",
    alt: "Buffalo King",
    name: "Buffalo King",
  },
  bubblewild2: {
    redirectUrl: "/casino/pragmaticplay-bubble-wild-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BubbleWild2.webp",
    alt: "Bubble Wild 2",
    name: "Bubble Wild 2",
  },
  bubblewild: {
    redirectUrl: "/casino/pragmaticplay-bubble-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BubbleWild.webp",
    alt: "Bubble Wild",
    name: "Bubble Wild",
  },
  bubblepop: {
    redirectUrl: "/casino/pragmaticplay-bubble-pop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BubblePop.webp",
    alt: "Bubble Pop",
    name: "Bubble Pop",
  },
  brickhousebonanza: {
    redirectUrl: "/casino/pragmaticplay-brick-house-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BrickHouseBonanza.webp",
    alt: "Brick House Bonanza",
    name: "Brick House Bonanza",
  },
  bowofartemis: {
    redirectUrl: "/casino/pragmaticplay-bow-of-artemis",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BowofArtemis.webp",
    alt: "Bow of Artemis",
    name: "Bow of Artemis",
  },
  bountygold: {
    redirectUrl: "/casino/pragmaticplay-bounty-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BountyGold.webp",
    alt: "Bounty Gold",
    name: "Bounty Gold",
  },
  bookofvikings: {
    redirectUrl: "/casino/pragmaticplay-book-of-vikings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookofVikings.webp",
    alt: "Book of Vikings",
    name: "Book of Vikings",
  },
  bookofthefallen: {
    redirectUrl: "/casino/pragmaticplay-book-of-the-fallen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookoftheFallen.webp",
    alt: "Book of the Fallen",
    name: "Book of the Fallen",
  },
  bookofsports: {
    redirectUrl: "/casino/pragmaticplay-book-of-sports",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/bookofsports.webp",
    alt: "Book of Sports",
    name: "Book of Sports",
  },
  bookofkingdoms: {
    redirectUrl: "/casino/pragmaticplay-book-of-kingdoms",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookofKingdoms.webp",
    alt: "Book of Kingdoms",
    name: "Book of Kingdoms",
  },
  bookofgoldensands: {
    redirectUrl: "/casino/pragmaticplay-book-of-golden-sands",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookofGoldenSands.webp",
    alt: "Book of Golden Sands",
    name: "Book of Golden Sands",
  },
  bookofeldorado: {
    redirectUrl: "/casino/pragmaticplay-book-of-el-dorado",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookofElDorado.webp",
    alt: "Book of El Dorado",
    name: "Book of El Dorado",
  },
  bookofaztecking: {
    redirectUrl: "/casino/pragmaticplay-book-of-aztec-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BookofAztecKing.webp",
    alt: "Book of Aztec King",
    name: "Book of Aztec King",
  },
  bonanzagold: {
    redirectUrl: "/casino/pragmaticplay-bonanza-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BonanzaGold.webp",
    alt: "Bonanza Gold",
    name: "Bonanza Gold",
  },
  bombbonanza: {
    redirectUrl: "/casino/pragmaticplay-bomb-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BombBonanza.webp",
    alt: "Bomb Bonanza",
    name: "Bomb Bonanza",
  },
  blitzsuperwheel: {
    redirectUrl: "/casino/pragmaticplay-blitz-super-wheel",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BlitzSuperWheel.webp",
    alt: "Blitz Super Wheel",
    name: "Blitz Super Wheel",
  },
  blazingwildsmegaways: {
    redirectUrl: "/casino/pragmaticplay-blazing-wilds-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BlazingWildsMegaways.webp",
    alt: "Blazing Wilds Megaways",
    name: "Blazing Wilds Megaways",
  },
  bladefangs: {
    redirectUrl: "/casino/pragmaticplay-blade-and-fangs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BladeFangs.webp",
    alt: "Blade & Fangs",
    name: "Blade & Fangs",
  },
  blackbull: {
    redirectUrl: "/casino/pragmaticplay-black-bull",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BlackBull.webp",
    alt: "Black Bull",
    name: "Black Bull",
  },
  bisonspirit: {
    redirectUrl: "/casino/pragmaticplay-bison-spirit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BisonSpirit.webp",
    alt: "Bison Spirit",
    name: "Bison Spirit",
  },
  bisonblaze: {
    redirectUrl: "/casino/pragmaticplay-bison-blaze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/bisonblaze.webp",
    alt: "Bison Blaze",
    name: "Bison Blaze",
  },
  biggerbasssplash: {
    redirectUrl: "/casino/pragmaticplay-bigger-bass-splash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BiggerBassSplash.webp",
    alt: "Bigger Bass Splash",
    name: "Bigger Bass Splash",
  },
  biggerbassbonanza: {
    redirectUrl: "/casino/pragmaticplay-bigger-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BiggerBassBonanza.webp",
    alt: "Bigger Bass Bonanza",
    name: "Bigger Bass Bonanza",
  },
  biggerbassblizzardchristmascatch: {
    redirectUrl: "/casino/pragmaticplay-bigger-bass-blizzard-christmas-catch",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BiggerBassBlizzardChristmasCatch.webp",
    alt: "Bigger Bass Blizzard  Christmas Catch",
    name: "Bigger Bass Blizzard  Christmas Catch",
  },
  bigjuan: {
    redirectUrl: "/casino/pragmaticplay-big-juan",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigJuan.webp",
    alt: "Big Juan",
    name: "Big Juan",
  },
  bigburgerloaditupwithxtracheese: {
    redirectUrl: "/casino/pragmaticplay-big-burger-load-it-up-with-xtra-cheese",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBurgerLoaditupwithXtraCheese.webp",
    alt: "Big Burger Load it up with Xtra Cheese",
    name: "Big Burger Load it up with Xtra Cheese",
  },
  bigbassxmasextreme: {
    redirectUrl: "/casino/pragmaticplay-big-bass-xmas-extreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassXmasExtreme.webp",
    alt: "Big Bass Xmas Extreme",
    name: "Big Bass Xmas Extreme",
  },
  bigbassvegasdoubledowndeluxe: {
    redirectUrl: "/casino/pragmaticplay-big-bass-vegas-double-down-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassVegasDoubleDownDeluxe.webp",
    alt: "Big Bass Vegas Double Down Deluxe",
    name: "Big Bass Vegas Double Down Deluxe",
  },

  bigbassholdspinnermegaways: {
    redirectUrl: "/casino/pragmaticplay-big-bass-hold-and-spinner-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassHold&SpinnerMegaways.webp",
    alt: "Big Bass Hold & Spinner Megaways",
    name: "Big Bass Hold & Spinner Megaways",
  },
  bigbasshalloween2: {
    redirectUrl: "/casino/pragmaticplay-big-bass-halloween-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassHalloween2.webp",
    alt: "Big Bass Halloween 2",
    name: "Big Bass Halloween 2",
  },

  bigbassfloatsmyboat: {
    redirectUrl: "/casino/pragmaticplay-big-bass-floats-my-boat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassFloatsmyBoat.webp",
    alt: "Big Bass Floats my Boat",
    name: "Big Bass Floats my Boat",
  },
  bigbassdice: {
    redirectUrl: "/casino/pragmaticplay-big-bass-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassDice.webp",
    alt: "Big Bass Dice",
    name: "Big Bass Dice",
  },
  bigbassdayattheraces: {
    redirectUrl: "/casino/pragmaticplay-big-bass-day-at-the-races",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassDayattheRaces.webp",
    alt: "Big Bass Day at the Races",
    name: "Big Bass Day at the Races",
  },
  bigbasschristmasbash: {
    redirectUrl: "/casino/pragmaticplay-big-bass-christmas-bash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassChristmasBash.webp",
    alt: "Big Bass Christmas Bash",
    name: "Big Bass Christmas Bash",
  },
  bigbassboxingbonusround: {
    redirectUrl: "/casino/pragmaticplay-big-bass-boxing-bonus-round",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBoxingBonusRound.webp",
    alt: "Big Bass Boxing Bonus Round",
    name: "Big Bass Boxing Bonus Round",
  },
  bigbassbonanzamegaways: {
    redirectUrl: "/casino/pragmaticplay-big-bass-bonanza-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBonanzaMegaways.webp",
    alt: "Big Bass Bonanza Megaways",
    name: "Big Bass Bonanza Megaways",
  },
  bigbassbonanza3reeler: {
    redirectUrl: "/casino/pragmaticplay-big-bass-bonanza-3-reeler",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBonanza3Reeler.webp",
    alt: "Big Bass Bonanza 3 Reeler",
    name: "Big Bass Bonanza 3 Reeler",
  },
  bigbassbonanza1000: {
    redirectUrl: "/casino/pragmaticplay-big-bass-bonanza-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBonanza1000.webp",
    alt: "Big Bass Bonanza 1000",
    name: "Big Bass Bonanza 1000",
  },
  bigbassbonanzareelaction: {
    redirectUrl: "/casino/pragmaticplay-big-bass-bonanza-reel-action",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassBonanzaReelAction.webp",
    alt: "Big Bass Bonanza - Reel Action",
    name: "Big Bass Bonanza - Reel Action",
  },

  bigbassamazonxtreme: {
    redirectUrl: "/casino/pragmaticplay-big-bass-amazon-xtreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassAmazonXtreme.webp",
    alt: "Big Bass Amazon Xtreme",
    name: "Big Bass Amazon Xtreme",
  },
  bigbasskeepingitreel: {
    redirectUrl: "/casino/pragmaticplay-big-bass-keeping-it-reel",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassKeepingitReel.webp",
    alt: "Big Bass Keeping it Reel",
    name: "Big Bass Keeping it Reel",
  },
  bigbassholdspinner: {
    redirectUrl: "/casino/pragmaticplay-big-bass-hold-and-spinner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BigBassHold&Spinner.webp",
    alt: "Big Bass Hold & Spinner",
    name: "Big Bass Hold & Spinner",
  },
  beowulf: {
    redirectUrl: "/casino/pragmaticplay-beowulf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Beowulf.webp",
    alt: "Beowulf",
    name: "Beowulf",
  },
  barnyardmegahaysmegaways: {
    redirectUrl: "/casino/pragmaticplay-barnyard-megahays-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BarnyardMegahaysMegaways.webp",
    alt: "Barnyard Megahays Megaways",
    name: "Barnyard Megahays Megaways",
  },
  barnfestival: {
    redirectUrl: "/casino/pragmaticplay-barn-festival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BarnFestival.webp",
    alt: "Barn Festival",
    name: "Barn Festival",
  },
  barbar: {
    redirectUrl: "/casino/pragmaticplay-barbar",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Barbar.webp",
    alt: "Barbar",
    name: "Barbar",
  },
  banditmegaways: {
    redirectUrl: "/casino/pragmaticplay-bandit-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BanditMegaways.webp",
    alt: "Bandit Megaways",
    name: "Bandit Megaways",
  },
  balidragon: {
    redirectUrl: "/casino/pragmaticplay-bali-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BaliDragon.webp",
    alt: "Bali Dragon",
    name: "Bali Dragon",
  },
  badgeblitz: {
    redirectUrl: "/casino/pragmaticplay-badge-blitz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/BadgeBlitz.webp",
    alt: "Badge Blitz",
    name: "Badge Blitz",
  },
  aztectreasurehunt: {
    redirectUrl: "/casino/pragmaticplay-aztec-treasure-hunt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecTreasureHunt.webp",
    alt: "Aztec Treasure Hunt",
    name: "Aztec Treasure Hunt",
  },
  aztectreasure: {
    redirectUrl: "/casino/pragmaticplay-aztec-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecTreasure.webp",
    alt: "Aztec Treasure",
    name: "Aztec Treasure",
  },
  aztecsmash: {
    redirectUrl: "/casino/pragmaticplay-aztec-smash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecSmash.webp",
    alt: "Aztec Smash",
    name: "Aztec Smash",
  },
  aztecpowernudge: {
    redirectUrl: "/casino/pragmaticplay-aztec-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecPowernudge.webp",
    alt: "Aztec Powernudge",
    name: "Aztec Powernudge",
  },
  azteckingmegaways: {
    redirectUrl: "/casino/pragmaticplay-aztec-king-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecKingMegaways.webp",
    alt: "Aztec King Megaways",
    name: "Aztec King Megaways",
  },
  aztecking: {
    redirectUrl: "/casino/pragmaticplay-aztec-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecKing.webp",
    alt: "Aztec King",
    name: "Aztec King",
  },
  aztecgemsmegaways: {
    redirectUrl: "/casino/pragmaticplay-aztec-gems-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecGemsMegaways.webp",
    alt: "Aztec Gems Megaways",
    name: "Aztec Gems Megaways",
  },
  aztecgemsdeluxe: {
    redirectUrl: "/casino/pragmaticplay-aztec-gems-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecGemsDeluxe.webp",
    alt: "Aztec Gems Deluxe",
    name: "Aztec Gems Deluxe",
  },
  aztecgems: {
    redirectUrl: "/casino/pragmaticplay-aztec-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecGems.webp",
    alt: "Aztec Gems",
    name: "Aztec Gems",
  },
  aztecbonanza: {
    redirectUrl: "/casino/pragmaticplay-aztec-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecBonanza.webp",
    alt: "Aztec Bonanza",
    name: "Aztec Bonanza",
  },
  aztecblaze: {
    redirectUrl: "/casino/pragmaticplay-aztec-blaze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AztecBlaze.webp",
    alt: "Aztec Blaze",
    name: "Aztec Blaze",
  },
  atlanticmoneymouse: {
    redirectUrl: "/casino/pragmaticplay-atlantic-money-mouse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AtlanticMoneyMouse.webp",
    alt: "Atlantic Money Mouse",
    name: "Atlantic Money Mouse",
  },
  asgard: {
    redirectUrl: "/casino/pragmaticplay-asgard",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Asgard.webp",
    alt: "Asgard",
    name: "Asgard",
  },
  argonauts: {
    redirectUrl: "/casino/pragmaticplay-argonauts",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/Argonauts.webp",
    alt: "Argonauts",
    name: "Argonauts",
  },
  angelvssinner: {
    redirectUrl: "/casino/pragmaticplay-angel-vs-sinner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AngelvsSinner.webp",
    alt: "Angel vs Sinner",
    name: "Angel vs Sinner",
  },
  ancientislandmegaways: {
    redirectUrl: "/casino/pragmaticplay-ancient-island-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AncientIslandMegaways.webp",
    alt: "Ancient Island Megaways",
    name: "Ancient Island Megaways",
  },
  ancientegyptclassic: {
    redirectUrl: "/casino/pragmaticplay-ancient-egypt-classic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AncientEgyptClassic.webp",
    alt: "Ancient Egypt Classic",
    name: "Ancient Egypt Classic",
  },
  ancientegypt: {
    redirectUrl: "/casino/pragmaticplay-ancient-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AncientEgypt.webp",
    alt: "Ancient Egypt",
    name: "Ancient Egypt",
  },
  alieninvaders: {
    redirectUrl: "/casino/pragmaticplay-alien-invaders",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AlienInvaders.webp",
    alt: "Alien Invaders",
    name: "Alien Invaders",
  },
  aladdinandthesorcerer: {
    redirectUrl: "/casino/pragmaticplay-alien-invaders",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AladdinandtheSorcerer.webp",
    alt: "Aladdin and the Sorcerer",
    name: "Aladdin and the Sorcerer",
  },
  africanelephant: {
    redirectUrl: "/casino/pragmaticplay-african-elephant",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/AfricanElephant.webp",
    alt: "African Elephant",
    name: "African Elephant",
  },
  gold888: {
    redirectUrl: "/casino/pragmaticplay-888-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/888Gold.webp",
    alt: "888 Gold",
    name: "888 Gold",
  },
  dragons888: {
    redirectUrl: "/casino/pragmaticplay-888-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/888Dragons.webp",
    alt: "888 Dragons",
    name: "888 Dragons",
  },
  goldendragonchallenge8: {
    redirectUrl: "/casino/pragmaticplay-8-golden-dragon-challenge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/8GoldenDragonChallenge.webp",
    alt: "8 Golden Dragon Challenge",
    name: "8 Golden Dragon Challenge",
  },
  dragons8: {
    redirectUrl: "/casino/pragmaticplay-8-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/8Dragons.webp",
    alt: "8 Dragons",
    name: "8 Dragons",
  },
  piggies7: {
    redirectUrl: "/casino/pragmaticplay-7-piggies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/7Piggies.webp",
    alt: "7 Piggies",
    name: "7 Piggies",
  },
  monkeys7: {
    redirectUrl: "/casino/pragmaticplay-7-monkeys",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/7Monkeys.webp",
    alt: "7 Monkeys",
    name: "7 Monkeys",
  },
  cloversoffortune7: {
    redirectUrl: "/casino/pragmaticplay-7-clovers-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/7CloversofFortune.webp",
    alt: "7 Clovers of Fortune",
    name: "7 Clovers of Fortune",
  },
  jokers6: {
    redirectUrl: "/casino/pragmaticplay-6-jokers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/6Jokers.webp",
    alt: "6 Jokers",
    name: "6 Jokers",
  },
  rabbitsmegaways5: {
    redirectUrl: "/casino/pragmaticplay-5-rabbits-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/5RabbitsMegaways.webp",
    alt: "5 Rabbits Megaways",
    name: "5 Rabbits Megaways",
  },
  lionsmegaways5: {
    redirectUrl: "/casino/pragmaticplay-5-lions-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/5LionsMegaways.webp",
    alt: "5 Lions Megaways",
    name: "5 Lions Megaways",
  },
  lionsdance5: {
    redirectUrl: "/casino/pragmaticplay-5-lions-dance",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/5LionsDance.webp",
    alt: "5 Lions Dance",
    name: "5 Lions Dance",
  },
  lions5: {
    redirectUrl: "/casino/pragmaticplay-5-lions",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/5Lions.webp",
    alt: "5 Lions",
    name: "5 Lions",
  },
  lionsgold5: {
    redirectUrl: "/casino/pragmaticplay-5-lions-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/5LionsGold.webp",
    alt: "5 Lions Gold",
    name: "5 Lions Gold",
  },
  geniewishes3: {
    redirectUrl: "/casino/pragmaticplay-3-genie-wishes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/3GenieWishes.webp",
    alt: "3 Genie Wishes",
    name: "3 Genie Wishes",
  },
  dancingmonkeys3: {
    redirectUrl: "/casino/pragmaticplay-3-dancing-monkeys",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/3DancingMonkeys.webp",
    alt: "3 Dancing Monkeys",
    name: "3 Dancing Monkeys",
  },
  buzzingwilds3: {
    redirectUrl: "/casino/pragmaticplay-3-buzzing-wilds",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/3BuzzingWilds.webp",
    alt: "3 Buzzing Wilds",
    name: "3 Buzzing Wilds",
  },
  nights1001: {
    redirectUrl: "/casino/pragmaticplay-1001-nights",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/pragmaticplay/1001Nights.webp",
    alt: "1001 Nights",
    name: "1001 Nights",
  },
};
